import '../../app-configuration/app-configuration.js';
import '@polymer/polymer/polymer-legacy.js';
import '@polymer/iron-icons/social-icons.js';
import '@polymer/iron-icons/communication-icons.js';
import '@polymer/neon-animation/neon-animation.js';
import '@polymer/paper-radio-button/paper-radio-button.js';
import '@polymer/paper-radio-group/paper-radio-group.js';
import '@polymer/paper-toast/paper-toast.js';
import '@polymer/iron-form/iron-form.js';
import '@polymer/gold-cc-input/gold-cc-input.js';
import '@polymer/gold-cc-expiration-input/gold-cc-expiration-input.js';
import '@polymer/gold-cc-cvc-input/gold-cc-cvc-input.js';
import '../katapult-map-icons/katapult-map-icons.js';
import '../katapult-elements/katapult-icon.js';
import '../style-modules/paper-tooltip-style.js';
import '../style-modules/paper-menu-button-style.js';
import '../katapult-elements/katapult-cc-input/katapult-cc-input.js';
import { CamelCase } from '../../modules/CamelCase.js';
import '../katapult-auth/katapult-auth.js';
import '../katapult-toolbar/katapult-toolbar.js';
import '../paper-table/paper-table.js';
import './pole-app-portal-company-options.js';
import { ServerRequest } from '../../modules/ServerRequest.js';
import '../katapult-account-settings/katapult-contact-info.js';
import '../model-loader/model-loader.js';
import '../input-element/input-element.js';
import { KatapultPageElement, html } from '../../mixins/katapult-page-element.js';
import '../paper-header/paper-header.js';
import '../material-icon/material-icon.js';
import '../katapult-elements/katapult-button.js';
import { FormatDate, HowLong } from '../../modules/Date.js';
import { ToArray } from '../../modules/ToArray.js';
import { Path } from '../../modules/Path.js';
import './cross-server-job-sharing.js';
import './server-access-manager.js';
import { addFlagListener, removeFlagListener } from '../../modules/FeatureFlags.js';
import './company-authentication-options.js';
import './company-billing-options.js';
import { Throttle } from '../../modules/Throttle.js';
import { GetCompanyNames } from '../../modules/GetCompanyNames.js';
import { MLD } from '../../modules/MasterLocationDirectory.js';
import { ListenToUserRoles, SetUserRole } from '../../modules/Roles.js';
import { CallCrossServerIdentityAction } from '../../modules/CallCrossServerIdentityAction.js';
import { KatapultDialog } from '../katapult-elements/katapult-dialog.js';
import './user-server-access-dialog.js';
import { _checkCrossServerIdentity, checkIfCompanyIdInUse } from '../../modules/ServerIdentity.js';
import { NameToKey } from '../../modules/NameToKey.js';
import '../date-time-dialog/date-time-dialog.js';
import { capitalCase } from 'change-case';
import '@shoelace-style/shoelace/dist/components/tooltip/tooltip.js';
import { html as litHtml } from 'lit';
import { RemoveUserCompanyPermissions, SetUserReadPermission, SetUserCompanyAdmin } from '../../modules/UserPermissions.js';
import { KatapultBanner } from '../katapult-elements/katapult-banner.js';
import { ExternalUserDialog } from './external-user-dialog.js';
import { config } from '../../app-configuration/config.js';
import './admin-dashboard-users-list.js';
import { listenToTransferLocking } from '../../modules/TransferLocking.js';

/** @import { PaperToggleButtonElement } from '@polymer/paper-toggle-button/paper-toggle-button.js' */
/** @import { PaperInputElement } from '@polymer/paper-input/paper-input.js' */
/** @import { PaperDialogElement } from '@polymer/paper-dialog/paper-dialog.js' */
/** @import { PaperCheckboxElement } from '@polymer/paper-checkbox/paper-checkbox.js' */

class AdminDashboard extends KatapultPageElement {
  static get template() {
    return html`
      <style include="paper-tooltip-style paper-menu-button-style paper-dialog-style">
        [hidden] {
          display: none;
        }
        .searchWrapper {
          display: flex;
          align-items: center;
          width: 300px;
        }
        .searchWrapper > paper-input {
          flex-grow: 1;
        }
        #createCompany {
          width: 56px;
        }
        katapult-toolbar katapult-button {
          color: var(--primary-text-color-faded);
        }
        div[slot='auth-content'] {
          display: flex;
          flex-direction: column;
        }
        div[slot='auth-content'] > div {
          display: flex;
          flex-grow: 1;
          overflow: hidden;
        }
        #editCompanyContainer,
        #editUserContainer {
          transition: margin 0.3s;
          @apply --shadow-elevation-2dp;
        }
        #editCompanyContainer {
          display: flex;
          flex-direction: column;
          width: 360px;
        }
        #editCompanyContainer:not([visible]) {
          margin-left: -360px;
        }
        #editCompanyContainer .scrollContent,
        #editUserContainer .scrollContent {
          display: flex;
          flex-direction: column;
          flex-grow: 1;
          overflow-y: auto;
          overflow-x: hidden;
        }
        #editCompanyContainer .buttons,
        #editUserContainer .buttons,
        [buttons] {
          display: flex;
          padding: 16px;
          justify-content: space-between;
          gap: 8px;
        }
        #editCompanyHeader {
          display: flex;
          align-items: center;
          font-size: 18pt;
          font-weight: lighter;
        }
        #editCompanyHeader katapult-icon {
          margin: 8px;
          flex-shrink: 0;
        }
        #editCompanyHeader span {
          overflow: hidden;
          text-overflow: ellipsis;
        }
        #editUserContainer {
          display: flex;
          flex-direction: column;
          width: 360px;
        }
        #editUserContainer:not([visible]) {
          margin-right: -360px;
        }
        #editUserHeader {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 16px;
          color: var(--primary-text-color-faded);
        }
        #editUserHeader user-chip {
          margin: 8px;
          --user-chip-profile: {
            width: 96px;
            height: 96px;
            font-size: 44pt;
          };
        }
        #editUserContainer span {
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          margin: 4px;
        }
        #editUserHeader .name {
          font-size: 18pt;
          font-weight: lighter;
          color: var(--primary-text-color);
        }
        #editUserHeader .buttons {
          position: absolute;
          top: 0;
          right: 0;
          color: var(--primary-text-color-faded);
        }
        #editUserHeader .buttons paper-menu-button {
          padding: 0;
        }
        .optionRow {
          display: flex;
          align-items: center;
          color: var(--primary-text-color-faded);
          font-size: 11pt;
          padding: 8px 16px;
          min-height: 58px;
          box-sizing: border-box;
          border-top: 1px solid var(--paper-grey-100);
        }
        .optionRow:last-of-type {
          border-bottom: 1px solid var(--paper-grey-200);
        }
        .optionRow input-element {
          flex-grow: 1;
          margin: 0 4px;
        }
        .optionRow span {
          flex-grow: 1;
        }
        paper-toggle-button {
          --primary-color: var(--secondary-color);
        }
        paper-dialog {
          max-width: 800px;
          min-width: 400px;
        }
        .permissionRegion {
          margin-top: 16px;
          color: var(--primary-text-color-faded);
          font-size: 16px;
        }
        .optionWrapper {
          padding: 12px 8px;
          display: flex;
          justify-content: space-around;
          --paper-checkbox-label: {
            opacity: 1 !important;
          };
        }
        .licensePaperTable > paper-row:nth-child(even) {
          background-color: var(--paper-grey-50);
        }
        #billableHoursTable {
          padding: 10px 0px 0px 10px;
        }
        paper-radio-button {
          --primary-color: var(--secondary-color);
          --primary-text-color: var(--primary-text-color-faded);
        }
        .optionRow paper-radio-group {
          display: flex;
          flex-direction: column;
        }
        paper-radio-button {
          --primary-color: var(--secondary-color);
          --primary-text-color: var(--primary-text-color-faded);
        }
        .optionRow paper-radio-group {
          display: flex;
          flex-direction: column;
        }
        .MFADialogBody {
          font-size: 17px;
          width: 500px;
          text-align: center;
        }
        katapult-button:not([iconOnly]) {
          min-width: 75px;
        }
        .notice-card {
          display: flex;
          gap: 20px;
          align-items: flex-start;
          padding: 8px;
          border-radius: 8px;
          background-color: var(--paper-blue-50);
        }
        .roles-options-list {
          display: flex;
          flex-direction: column;
          color: var(--primary-text-color-faded);
        }
        .role-row {
          padding: 16px 0;
          display: flex;
          flex-direction: column;
          gap: 16px;
        }
        .role-row:not(:last-of-type) {
          border-bottom: 1px solid var(--paper-grey-100);
        }
        .role-title-and-toggle {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .role-description {
          font-size: 14px;
        }
        #gettingStartedBox {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border: 2px solid var(--sl-color-primary);
          border-radius: var(--sl-border-radius-x-large);
          padding: var(--sl-spacing-small);
          margin: var(--sl-spacing-medium);
          gap: var(--sl-spacing-x-small);
        }
      </style>
      <firebase-document path=".info/serverTimeOffset" data="{{serverTimeOffset}}"></firebase-document>
      <firebase-document path="/photoheight/help/admin_page_config" data="{{adminPageConfig}}"></firebase-document>
      <excel-exports id="excelExports" user-group="[[userGroup]]"></excel-exports>
      <katapult-map-icons></katapult-map-icons>
      <paper-toast id="toast"></paper-toast>

      <katapult-dialog id="rolesDialog" title="Roles" width="400">
        <div class="roles-options-list">
          <div style="padding-bottom: 16px;">
            <span style="overflow-wrap: break-word;">Viewing roles for:<br /><strong>[[editUserData.email]]</strong></span>
          </div>
          <div class="role-row">
            <div class="role-title-and-toggle">
              <span>Model Editor Read Permission</span>
              <paper-toggle-button
                disabled$="[[editUserData.roles.photoheight.permissions.model_editor_write_access]]"
                data-flag="model_editor_read_access"
                checked="[[editUserData.roles.photoheight.permissions.model_editor_read_access]]"
                on-click="changePermissionFlag"
              ></paper-toggle-button>
            </div>
          </div>
          <div class="role-row">
            <div class="role-title-and-toggle">
              <span>Model Editor Write Permission</span>
              <paper-toggle-button
                data-flag="model_editor_write_access"
                checked="[[editUserData.roles.photoheight.permissions.model_editor_write_access]]"
                on-click="changePermissionFlag"
              ></paper-toggle-button>
            </div>
          </div>
          <div class="role-row">
            <div class="role-title-and-toggle">
              <span>API Access</span>
              <paper-toggle-button
                data-flag="api_access"
                checked="[[editUserData.roles.photoheight.permissions.api_access]]"
                on-click="changePermissionFlag"
              ></paper-toggle-button>
            </div>
          </div>
          <template is="dom-if" if="[[subscription.modules.mobile_assessment]]">
            <div class="role-row">
              <div class="role-title-and-toggle">
                <span>Mobile Assessments Workflow</span>
                <sl-tooltip placement="right" hoist>
                  <div style="display: flex" slot="content">
                    This user will only have permission to access Katapult Pro Mobile and the Photo Upload page.
                  </div>
                  <katapult-icon icon="warning" color="var(--paper-orange-500)"></katapult-icon>
                </sl-tooltip>
                <paper-toggle-button
                  disabled$="[[equal(user.uid, editUserRef.uid)]]"
                  data-path="editUserData.workflows.mobile_assessment"
                  checked="[[editUserData.workflows.mobile_assessment]]"
                  on-change="toggleProperty"
                ></paper-toggle-button>
              </div>
            </div>
          </template>
          <template is="dom-if" if="[[enabledFeatures.job_locking]]">
            <div class="role-row">
              <div class="role-title-and-toggle">
                <span>Job Unlocking Permission</span>
                <paper-toggle-button
                  data-flag="job_unlocking_access"
                  checked="[[editUserData.roles.photoheight.permissions.job_unlocking_access]]"
                  on-click="changePermissionFlag"
                ></paper-toggle-button>
              </div>
            </div>
          </template>
          <template is="dom-if" if="[[editUserData.workflows.pole_app_portal]]">
            <div class="role-row">
              <div class="role-title-and-toggle">
                <span>Application Manager</span>
                <paper-toggle-button
                  disabled="[[roleToggleDisabled('application_manager', user.uid, systemAdmin, companyUsersRoles)]]"
                  checked="[[getSub(companyUsersRoles, editUserRef.uid, 'application_manager')]]"
                  data-user-role="application_manager"
                  on-click="toggleUserRole"
                ></paper-toggle-button>
              </div>
              <div class="role-description">User may submit drafts and advance portal applications using status buttons</div>
            </div>
          </template>
          <template is="dom-if" if="[[timesheetsEnabled]]">
            <div class="role-row">
              <div class="role-title-and-toggle">
                <span>Timesheet Manager</span>
                <paper-toggle-button
                  disabled="[[roleToggleDisabled('timesheet_manager', user.uid, systemAdmin, companyUsersRoles)]]"
                  checked="[[getSub(companyUsersRoles, editUserRef.uid, 'timesheet_manager')]]"
                  data-user-role="timesheet_manager"
                  on-click="toggleUserRole"
                ></paper-toggle-button>
              </div>
              <div class="role-description">User may view all user's timesheet data and lock/unlock timesheets</div>
            </div>
          </template>
        </div>
        <div slot="buttons">
          <katapult-button dialog-dismiss>Done</katapult-button>
        </div>
      </katapult-dialog>

      <!-- Server Access Dialog -->
      <template is="dom-if" if="[[isHomeServerForCompany]]">
        <user-server-access-dialog
          id="userServerAccessDialog"
          user-id="[[editUserRef.uid]]"
          company-id="[[editUserRef.companyId]]"
          company-name="[[getCompanyName(editUserRef.companyId)]]"
          user-email="[[editUserRef.email]]"
          user-company-permissions="[[editUserData.company_permissions]]"
          user-read-permission="[[editUserData.read_permission]]"
          user-write-permission="[[editUserData.write_permission]]"
          user-admin-permission="[[editUserData.roles.photoheight.company_admin]]"
        ></user-server-access-dialog>
      </template>

      <katapult-auth
        user="{{user}}"
        user-record="{{currentUserData}}"
        user-group="{{userGroup}}"
        root-company="{{rootCompany}}"
        system-admin="{{systemAdmin}}"
        admin="{{isAdmin}}"
        signed-in="{{signedIn}}"
        read-only="{{readOnlyUser}}"
        title="[[config.firebaseData.name]] Admin Dashboard"
        signup-link="https://katapultpro.com/signup"
        no-signup="[[!config.firebaseData.offerLicenses]]"
        block-auth-content="[[!_userCanViewPage(currentUserData, canReadAllUsers, isAdmin)]]"
      >
        <span slot="forbidden-message"
          >You do not have permission to view this page. Please contact your company administrator for assistance.</span
        >
        <div slot="title-content">
          <p style="margin: 0;">[[config.firebaseData.name]] Maps</p>
        </div>
        <div id="loginDescription" slot="description-content">
          <p>[[config.firebaseData.name]] Maps allows you to design and share survey jobs with Maps and Photos from any computer.</p>
          <p>Gather data for a permanent record of real-world conditions in minutes!</p>
        </div>
        <div slot="auth-content">
          <!-- Paper Dialogs -->
          <paper-dialog id="confirmAddLicenseDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title secondary-color>Add [[additionalLicenses]] License[[s(additionalLicenses)]]</div>
            <div body>
              Are you sure that you want to add [[additionalLicenses]] additional license[[s(additionalLicenses)]] to
              [[getCompanyName(companyId, companies)]]?
            </div>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button
                color="var(--secondary-color)"
                on-click="confirmAddLicense"
                loading="[[addingLicenses]]"
                disabled="[[equal(additionalLicenses, '0')]]"
                >Add [[additionalLicenses]] License[[s(additionalLicenses)]]</katapult-button
              >
            </div>
          </paper-dialog>
          <paper-dialog id="addLicenseErrorDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title="" amber="">Error Reported</div>
            <div body="">
              <div>
                There was an error when trying to update your license count. The Katapult Pro Team has received an email notification
                outlining what went wrong and will contact you shortly to resolve this issue.
              </div>
            </div>
            <div buttons>
              <katapult-button color="var(--paper-amber-500)" dialog-dismiss>Okay</katapult-button>
            </div>
          </paper-dialog>
          <paper-dialog id="removeYourAdminPermissionDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title="" amber="">Remove Your Admin Privileges</div>
            <div body="">
              <div>Are you sure that you want to remove your own admin privileges?</div>
              <div>You will no longer have access to this dashboard if you do.</div>
            </div>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button color="var(--paper-amber-500)" dialog-dismiss on-click="confirmChangeUserAdminStatus"
                >Continue</katapult-button
              >
            </div>
          </paper-dialog>
          <paper-dialog id="editContactInfoDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title="" secondary-color="">
              Edit Contact Info
              <material-icon
                icon="help_outline"
                style="vertical-align: center; cursor: default;"
                title="The information entered here should only be business contact information, and not personal."
              ></material-icon>
            </div>
            <katapult-contact-info
              body
              id="katapultContactInfo"
              user-record="[[editUserData]]"
              root-company="[[editUserRef.companyId]]"
              uid="[[editUserRef.uid]]"
            ></katapult-contact-info>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button color="var(--secondary-color)" loading="[[editContactInfoSaving]]" on-click="confirmEditContactInfo"
                >Save</katapult-button
              >
            </div>
          </paper-dialog>
          <paper-dialog id="approveUserDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title="" secondary-color="">Approve Request</div>
            <div body="">
              Are you sure you want to approve <b>[[approveUserTarget.email]]</b> to join
              <b>[[getCompanyName(approveUserTarget.companyId, companies)]]</b>?
            </div>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button color="var(--secondary-color)" loading="[[approvingUser]]" on-click="confirmApproveUser"
                >Approve</katapult-button
              >
            </div>
          </paper-dialog>
          <paper-dialog id="denyUserDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title="" amber="">Deny Request</div>
            <div body="">
              Are you sure you want to prevent <b>[[denyUserTarget.email]]</b> from joining
              <b>[[getCompanyName(denyUserTarget.companyId, companies)]]</b>?
            </div>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button color="var(--paper-amber-500)" loading="[[denyingUser]]" on-click="confirmDenyUser">Deny</katapult-button>
            </div>
          </paper-dialog>
          <paper-dialog id="deleteUserDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title="" red="">
              <material-icon icon="delete_forever"></material-icon>
              <div>Delete User</div>
            </div>
            <div body="">
              <div>Are you sure you want to delete <b>[[deleteUserTarget.email]]</b>?</div>
              <div>This action can not be undone</div>
              <div style="color:red">[[deleteUserErrorMessage]]</div>
            </div>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button color="var(--paper-red-500)" loading="[[deletingUser]]" on-click="confirmDeleteUser">Delete</katapult-button>
            </div>
          </paper-dialog>
          <paper-dialog id="createUserDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title secondary-color>
              <div>Create User</div>
            </div>
            <div body>
              <paper-input id="createUserEmailInput" label="Email" value="{{createUserEmail}}"></paper-input>
              <katapult-drop-down
                id="createUserCompanyInput"
                slot="left"
                label="Company"
                label-path="name"
                value-path="$key"
                items="[[companiesArray]]"
                value="{{createUserCompanyId}}"
                disabled
                required
                hidden$="[[!canWriteAllUsers]]"
              ></katapult-drop-down>
              <template is="dom-if" if="[[showCreateUserWorkflows]]">
                <div class="permissionRegion">
                  <div>
                    <template is="dom-if" if="[[!createUserWorkflowsError]]">
                      <div>Workflows</div>
                    </template>
                    <template is="dom-if" if="[[createUserWorkflowsError]]">
                      <div style="color: var(--paper-red-500);">Workflows - [[createUserWorkflowsError]]</div>
                    </template>
                  </div>
                  <div class="optionWrapper">
                    <template is="dom-repeat" items="[[createUserWorkflows]]">
                      <paper-checkbox checked="{{item.$val}}" on-click="checkboxClicked">[[camelCase(item.$key)]]</paper-checkbox>
                    </template>
                  </div>
                </div>
              </template>
              <div class="permissionRegion">
                <div>Permissions</div>
                <div style="display: flex; flex-direction: column; gap: 16px; padding: 16px;">
                  <template is="dom-if" if="[[showWriteOption]]">
                    <paper-checkbox checked="" disabled="">Read Permission</paper-checkbox>
                    <paper-checkbox checked="{{isWriteUser}}" disabled="[[!canCreateWriteUser]]">Write Permission</paper-checkbox>
                  </template>
                  <paper-checkbox checked="{{isCompanyAdmin}}">Company Admin</paper-checkbox>
                </div>
              </div>
              <!-- TODO (10-30-2024): When we add more roles here, this if statement will need to be made more complex -->
              <template is="dom-if" if="[[currentUserData.workflows.pole_app_portal]]">
                <div class="permissionRegion">
                  <div>Roles</div>
                  <div style="display: flex; flex-direction: column; gap: 16px; padding: 16px;">
                    <template is="dom-if" if="[[currentUserData.workflows.pole_app_portal]]">
                      <paper-checkbox
                        class="create-user-role-option"
                        data-user-role="application_manager"
                        disabled="[[roleToggleDisabled('application_manager', user.uid, systemAdmin, companyUsersRoles)]]"
                        >Application Manager</paper-checkbox
                      >
                    </template>
                  </div>
                </div>
              </template>
            </div>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button color="var(--secondary-color)" loading="[[creatingUser]]" on-click="confirmCreateUser"
                >Create</katapult-button
              >
            </div>
          </paper-dialog>

          <paper-dialog id="createCompanyDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title="" secondary-color="">
              <div>Create Company</div>
            </div>
            <div body="">
              <paper-input id="createCompanyNameInput" label="Company Name" value="{{createCompanyName}}"></paper-input>
            </div>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button color="var(--secondary-color)" loading="[[creatingCompany]]" on-click="confirmCreateCompany"
                >Create</katapult-button
              >
            </div>
          </paper-dialog>
          <paper-dialog id="resetPasswordDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title="" secondary-color="">
              <div>Reset User Password</div>
            </div>
            <div body="">
              <div>Are you sure you want to reset the password for <b>[[resetPasswordTarget.email]]</b>?</div>
              <div>They will receive a reset link to complete the reset process</div>
            </div>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button color="var(--secondary-color)" loading="[[resettingPassword]]" on-click="confirmResetPassword"
                >Send Reset Link</katapult-button
              >
            </div>
          </paper-dialog>
          <paper-dialog id="deleteCompanyDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
            <div title="" red="">
              <material-icon icon="delete_forever"></material-icon>
              <div>Delete Company</div>
            </div>
            <div body="">
              <div>Are you sure you want to delete <b>[[getCompanyName(companyId)]]</b>?</div>
              <div>This action will delete all of this company's users, models, and jobs, and cannot be undone.</div>
              <div><em>This action could take 5-10 minutes if the company has a large number of jobs shared with them.</em></div>
              <div style="color:red">[[deleteCompanyErrorMessage]]</div>
            </div>
            <div buttons>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button color="var(--paper-red-500)" loading="[[deletingCompany]]" on-click="confirmDeleteCompany"
                >Delete</katapult-button
              >
            </div>
          </paper-dialog>
          <katapult-dialog
            id="useMyHoursDialog"
            title="Use My Hours"
            on-confirm="useMyHours"
            confirm-text="Use My Hours"
            closeButton
            width="700"
          >
            <div class="sectionHeader" flex-row style="justify-content: space-between; align-items: center;">
              <div>Type of work:</div>
              <template is="dom-repeat" items="{{adminPageConfig.request_types}}" as="request">
                <div style="margin-top: 15px; margin-left: 20px; margin-right: 20px; text-wrap:auto">
                  <b>[[request.name]]</b>: [[request.description]]
                </div>
              </template>
              <katapult-drop-down
                id="useMyHoursTypeInput"
                label="Type"
                label-path="name"
                value-path="name"
                items="{{adminPageConfig.request_types}}"
                on-selected-changed="updateRequestType"
                required
              ></katapult-drop-down>
            </div>
            <paper-textarea
              id="useMyHoursNotesInput"
              label="Notes (Desired Functionality):"
              value="{{requestNote}}"
              autofocus=""
              underline
              width-fill-available
            ></paper-textarea>
            <div slot="buttons" flex space-between grow>
              <katapult-button dialog-dismiss>Cancel</katapult-button>
              <katapult-button
                color="var(--secondary-color)"
                callback="submitRequest"
                successMessage="Request Submitted"
                errorMessage="Error Submitting Request"
                >Send Request</katapult-button
              >
            </div>
          </katapult-dialog>
          <!-- Firebase -->
          <firebase-document path="photoheight/companies" data="{{companies}}" disabled="[[!signedIn]]"></firebase-document>
          <model-loader
            company-id="[[editUserRef.companyId]]"
            items='["attributes"]'
            other-attributes="{{editUserCompanyAttributes}}"
          ></model-loader>
          <firebase-document
            path="users/[[editUserRef.companyId]]/[[editUserRef.uid]]"
            data="{{editUserData}}"
            disabled="[[!signedIn]]"
          ></firebase-document>
          <firebase-document path="users/[[companyId]]" data="{{companyUsers}}" disabled="[[!signedIn]]"></firebase-document>
          <firebase-document
            path="photoheight/company_space/[[companyId]]/options/admin_dashboard"
            data="{{configOptions}}"
            disabled="[[!signedIn]]"
          ></firebase-document>
          <firebase-document
            path="photoheight/company_space/[[companyId]]/options/list/timesheets"
            data="{{timesheetsEnabled}}"
            disabled="[[!signedIn]]"
          ></firebase-document>
          <firebase-document
            path="photoheight/company_space/[[companyId]]/options/authentication/sign_in_options"
            data="{{companySignInOptions}}"
            disabled="[[!signedIn]]"
          ></firebase-document>
          <firebase-document
            path="photoheight/company_space/[[companyId]]/subscription"
            data="{{subscription}}"
            disabled="[[!signedIn]]"
          ></firebase-document>
          <firebase-document
            path="photoheight/company_space/[[companyId]]/address"
            data="{{address}}"
            disabled="[[!signedIn]]"
          ></firebase-document>
          <katapult-firebase-worker
            path="photoheight/company_space/[[companyId]]/home_server"
            data="{{companyHomeServer}}"
            disabled$="[[!signedIn]]"
          ></katapult-firebase-worker>
          <katapult-firebase-worker
            id="contacts"
            path="photoheight/company_space/[[userGroup]]/contacts"
            data="{{contacts}}"
            disabled="[[!signedIn]]"
          ></katapult-firebase-worker>
          <katapult-firebase-worker
            id="externalUsers"
            path="photoheight/company_space/[[companyId]]/external_users"
            data="{{companyExternalUsers}}"
            disabled="[[!signedIn]]"
          ></katapult-firebase-worker>
          <katapult-firebase-worker
            id="serverAccessSharingLinks"
            path="photoheight/company_space/[[userGroup]]/sharing_links/server_access"
            data="{{serverAccessSharingLinks}}"
            disabled="[[!signedIn]]"
          ></katapult-firebase-worker>
          <katapult-toolbar user-group="[[userGroup]]" simple-help="[[equal(config.firebaseData.utilityCompany, 'ppl_attachments')]]">
            <template is="dom-if" if="[[systemAdmin]]" restamp>
              <div slot="left" style="display: flex; gap: 8px; align-items: center;">
                <katapult-drop-down
                  label="Choose a Company"
                  label-path="name"
                  value-path="$key"
                  items="[[companiesArray]]"
                  value="{{companyId}}"
                  no-label-float=""
                ></katapult-drop-down>
              </div>
            </template>
            <div slot="center" class="searchWrapper">
              <material-icon icon="search"></material-icon>
              <paper-input label="Search Users" value="{{searchString}}" no-label-float=""></paper-input>
            </div>
            <katapult-button
              id="exportUsers"
              slot="right"
              icon="file_download"
              iconOnly
              noBorder
              on-click="exportUserData"
            ></katapult-button>
            <paper-tooltip slot="right" for="exportUsers">Export User Data</paper-tooltip>
            <template is="dom-if" if="[[enabledFeatures.export_all_user_data]]">
              <katapult-button
                id="exportAllUsers"
                slot="right"
                icon="group"
                iconOnly
                noBorder
                on-click="exportAllUserData"
              ></katapult-button>
              <paper-tooltip slot="right" for="exportAllUsers">Export All User Data</paper-tooltip>
            </template>
            <template is="dom-if" if="[[enabledFeatures.cross_server_user_permissions]]">
              <katapult-button
                id="exportCrossServerUserPermissions"
                slot="right"
                icon="group"
                iconOnly
                noBorder
                on-click="exportCrossServerUserPermissionsData"
              ></katapult-button>
              <paper-tooltip slot="right" for="exportCrossServerUserPermissions">Export Cross-Server User Permissions</paper-tooltip>
              <katapult-button
                id="exportCrossServerUserPermissionsAndRoles"
                slot="right"
                icon="engineering"
                iconOnly
                noBorder
                on-click="exportCrossServerUserPermissionsData"
              ></katapult-button>
              <paper-tooltip slot="right" for="exportCrossServerUserPermissionsAndRoles"
                >Export Cross-Server User Permissions and Roles</paper-tooltip
              >
            </template>
            <template is="dom-if" if="[[isHomeServerForCompany]]">
              <katapult-button
                id="createUser"
                slot="right"
                icon="person_add"
                iconOnly
                noBorder
                on-click="promptCreateUser"
                disabled="[[creatingUsersLockedForTransfer]]"
              ></katapult-button>
              <paper-tooltip slot="right" for="createUser">Create User</paper-tooltip>
            </template>
            <template is="dom-if" if="[[systemAdmin]]">
              <katapult-button
                id="createCompany"
                slot="right"
                icon="domain_add"
                iconOnly
                noBorder
                on-click="promptCreateCompany"
              ></katapult-button>
              <paper-tooltip slot="right" for="createCompany">Create Company</paper-tooltip>
            </template>
          </katapult-toolbar>

          <!-- Main Container -->
          <div>
            <div id="editCompanyContainer" visible$="[[exists(companyId)]]">
              <div style="padding: 8px; gap: 8px;">
                <div id="editCompanyHeader">
                  <template is="dom-if" if="[[isCompanyVerified]]">
                    <katapult-icon icon="business"></katapult-icon>
                  </template>
                  <template is="dom-if" if="[[!isCompanyVerified]]">
                    <sl-tooltip placement="bottom">
                      <katapult-icon icon="domain_disabled"></katapult-icon>
                      <div style="display: flex" slot="content">This company's identity has not been verified</div>
                    </sl-tooltip>
                  </template>
                  <span>[[getCompanyName(companyId, companies)]]</span>
                </div>
                <template is="dom-if" if="[[!isHomeServerForCompany]]">
                  <div class="notice-card" title="This is not the home server for this company">
                    <katapult-icon icon="flag"></katapult-icon>
                    <div>
                      <div style="font-weight: bold; margin-bottom: 4px;">Satellite Server Notice</div>
                      <div style="font-size: 10pt;">
                        Showing only those settings which apply to this company on this particular server. Switch to the
                        [[firstValid(companyHomeServerName, '[unspecified]')]] Server for additional company settings
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <!-- Company Settings -->
              <div class="scrollContent">
                <div style="flex-grow: 1">
                  <!-- Verification -->
                  <template is="dom-if" if="[[showCompanySettingsGroup('VERIFICATION', isCompanyVerified)]]">
                    <paper-header-content opened>
                      <paper-cell slot="header" style="cursor: pointer; gap: var(--sl-spacing-x-small);">
                        <katapult-icon icon="verified"></katapult-icon>
                        <span>Verification</span>
                      </paper-cell>
                      <div
                        slot="content"
                        style="display: flex; flex-direction: column; gap: 10px; justify-content: center; align-items: center; padding-top: 10px; padding-bottom: 10px;"
                      >
                        <div>Contact us to verify your company's account.</div>
                        <a href="https://meetings.hubspot.com/michael-lintal/scope-definition-meetings" target="_blank"
                          ><katapult-button icon="event" color="var(--secondary-color)">Schedule a Meeting</katapult-button></a
                        >
                      </div>
                    </paper-header-content>
                  </template>

                  <!-- Subscription Info & Billing -->
                  <template
                    is="dom-if"
                    if="[[showCompanySettingsGroup('SUBSCRIPTION_AND_BILLING', subscription, isHomeServerForCompany, isCompanyVerified)]]"
                  >
                    <paper-header-content>
                      <paper-cell slot="header" style="cursor: pointer; gap: var(--sl-spacing-x-small);">
                        <katapult-icon icon="edit"></katapult-icon>
                        <span>Write Licenses</span>
                        <span style="white-space: pre; margin-left: 8px; font-size: 12px;"
                          >(<b>[[numLicensedUsers]]</b> Used / <b>[[subscription.count]]</b> Total)</span
                        >
                      </paper-cell>
                      <paper-table class="licensePaperTable" slot="content">
                        <paper-row>
                          <paper-cell>Current Licenses</paper-cell>
                          <paper-cell>[[subscription.count]] License[[s(subscription.count)]]</paper-cell>
                        </paper-row>
                        <paper-row>
                          <paper-cell>Added Licenses</paper-cell>
                          <paper-cell>
                            <!-- Disable this input if company we are currently viewing does not match the user's root company -->
                            <paper-input
                              style="width: 48px; text-align: center; flex-shrink: 0;"
                              type="number"
                              min="0"
                              max="99"
                              value="{{additionalLicenses}}"
                              no-label-float
                              disabled="[[!equal(companyId, rootCompany)]]"
                              ><span slot="prefix">+</span></paper-input
                            >
                            <span>License[[s(additionalLicenses)]]</span>
                          </paper-cell>
                          <paper-cell>$[[additionalLicenseCost]]/mo</paper-cell>
                        </paper-row>
                        <paper-row>
                          <paper-cell>New Total</paper-cell>
                          <paper-cell>[[newTotalLicenses]] License[[s(newTotalLicenses)]]</paper-cell>
                        </paper-row>
                        <paper-row style="justify-content: center;">
                          <katapult-button
                            size="18"
                            color="var(--secondary-color)"
                            on-click="promptAddLicense"
                            loading="[[addingLicenses]]"
                            disabled="[[equal(additionalLicenses, '0')]]"
                            >Add [[additionalLicenses]] License[[s(additionalLicenses)]]</katapult-button
                          >
                        </paper-row>
                        <paper-row>
                          <paper-cell>
                            <p>
                              Need to remove some licenses? Please contact us at
                              <a href="mailto:support@katapultengineering.com">support@katapultengineering.com</a>
                            </p>
                          </paper-cell>
                        </paper-row>
                      </paper-table>
                    </paper-header-content>

                    <template is="dom-if" if="[[subscription.group_attribute]]">
                      <paper-header-content opened>
                        <paper-cell slot="header">Licenses Per [[camelCase(subscription.group_attribute)]]</paper-cell>
                        <paper-table id="licenseGroupsTable" slot="content">
                          <template is="dom-repeat" items="[[licenseGroups]]" as="group">
                            <paper-row>
                              <paper-cell style="justify-content: center;">[[group.$key]]</paper-cell>
                              <paper-cell style="justify-content: center;">[[group.$val]]</paper-cell>
                            </paper-row>
                          </template>
                        </paper-table>
                      </paper-header-content>
                    </template>

                    <template is="dom-if" if="[[subscription.code_hours]]">
                      <paper-header-content opened>
                        <paper-cell slot="header"
                          >Available Billable Hours ([[calcRemainingHours(subscription.code_hours.site_license,
                          subscription.code_hours.site_license_used)]])</paper-cell
                        >
                        <paper-table id="billableHoursTable" slot="content">
                          <template is="dom-if" if="{{subscription.code_hours.site_license}}">
                            <paper-row>
                              <paper-cell
                                ><paper-input
                                  style="width: 40%"
                                  type="number"
                                  label="Total Monthly Hours"
                                  value="{{subscription.code_hours.site_license}}"
                                  readonly
                                  min="0"
                                ></paper-input
                              ></paper-cell>
                            </paper-row>
                            <paper-row>
                              <paper-cell>
                                <katapult-button
                                  size="18"
                                  color="var(--secondary-color)"
                                  on-click="promptUseMyHours"
                                  loading="[[sendingHoursRequest]]"
                                  >Use My Hours
                                </katapult-button>
                              </paper-cell>
                            </paper-row>
                            <template is="dom-if" if="{{subscription.code_hours.site_license_used}}">
                              <paper-row>
                                <paper-cell
                                  ><paper-input
                                    style="width: 40%"
                                    type="number"
                                    label="Remaining Hours"
                                    value="[[calcRemainingHours(subscription.code_hours.site_license, subscription.code_hours.site_license_used)]]"
                                    readonly
                                    min="0"
                                  ></paper-input
                                ></paper-cell>
                              </paper-row>
                            </template>
                          </template>
                        </paper-table>
                      </paper-header-content>
                    </template>

                    <template is="dom-if" if="[[configOptions.endpoints]]">
                      <div class="optionRow">
                        <katapult-drop-down
                          items="{{toArray(configOptions.endpoints)}}"
                          value-path="$key"
                          readonly="{{!isAdmin}}"
                          label-path="$key"
                          value="{{selectedEndpoint}}"
                          label="Endpoint URL"
                          on-selected-changed="updateEndpointInUse"
                        ></katapult-drop-down>
                      </div>
                    </template>

                    <!-- Billing Options -->
                    <company-billing-options company-id="[[companyId]]"></company-billing-options>
                  </template>

                  <!-- Portal Company Settings -->
                  <template
                    is="dom-if"
                    if="[[showCompanySettingsGroup('PORTAL_COMPANY_SETTINGS', currentUserData.workflows.pole_app_portal, isCompanyVerified)]]"
                  >
                    <pole-app-portal-company-options
                      utility-company="[[config.firebaseData.utilityCompany]]"
                      company-id="[[companyId]]"
                      company-name="[[getCompanyName(companyId, companies)]]"
                      user-group="[[userGroup]]"
                      system-admin="[[hasUniversalSubmissionRole]]"
                      show-submission-options="[[canWriteCompanySubmissionOptions]]"
                      show-mr-notification-info="[[canWriteMrNotificationInfo]]"
                      is-portal-admin="[[isPortalAdmin]]"
                    ></pole-app-portal-company-options>
                  </template>

                  <!-- Auth Options -->
                  <template is="dom-if" if="[[showCompanySettingsGroup('AUTH_OPTIONS', isAdmin, isHomeServerForCompany)]]">
                    <company-authentication-options
                      company-id="[[companyId]]"
                      utility-company="[[config.firebaseData.utilityCompany]]"
                      server-password-expire-time="[[config.firebaseData.password.password_expire_time]]"
                      allow-sign-in-methods="[[enabledFeatures.sign_in_methods]]"
                      allow-email-sign-in="[[enabledFeatures.sign_in_method_email]]"
                      allow-google-sign-in="[[enabledFeatures.sign_in_method_google]]"
                      allow-microsoft-sign-in="[[enabledFeatures.sign_in_method_microsoft]]"
                      allow-enterprise-sso-sign-in="[[enabledFeatures.sign_in_method_enterprise_sso]]"
                      deactivate-users="[[enabledFeatures.deactivate_users]]"
                    ></company-authentication-options>
                  </template>

                  <!-- Google Drive Integration -->
                  <template
                    is="dom-if"
                    if="[[showCompanySettingsGroup('GOOGLE_DRIVE', userGroup, isHomeServerForCompany, isCompanyVerified)]]"
                  >
                    <paper-header-content>
                      <paper-cell slot="header" style="cursor: pointer; gap: var(--sl-spacing-x-small);">
                        <katapult-icon icon="add_to_drive"></katapult-icon>
                        <span>Google Drive Integration</span>
                      </paper-cell>
                      <div slot="content" style="display: flex; justify-content: center; padding-top: 10px; padding-bottom: 10px;">
                        <katapult-button icon="add" color="var(--secondary-color)" on-click="addGoogleDriveIntegration"
                          >Connect To Google Drive</katapult-button
                        >
                      </div>
                    </paper-header-content>
                  </template>

                  <!-- Cross-Server Job Sharing -->
                  <template
                    is="dom-if"
                    if="[[showCompanySettingsGroup('CROSS_SERVER_JOB_SHARING', enabledFeatures.cross_server_job_sharing, isCompanyVerified)]]"
                  >
                    <cross-server-job-sharing company-id="[[companyId]]" disabled="[[!signedIn]]"></cross-server-job-sharing>
                  </template>

                  <!-- Master Location Directory Sharing -->
                  <template
                    is="dom-if"
                    if="[[showCompanySettingsGroup('MLD_SHARING', enabledFeatures.master_location_directory_sharing, isCompanyVerified)]]"
                  >
                    <paper-header-content>
                      <paper-cell slot="header" style="cursor: pointer;">Master Location Directory Sharing</paper-cell>
                      <div
                        slot="content"
                        style="display: flex; justify-content: center; padding-top: 10px; padding-bottom: 10px; flex-direction: column; padding: 1em"
                      >
                        <share-job
                          id="shareMLD"
                          user-group="[[userGroup]]"
                          company-names="[[sharingCompanyNames]]"
                          contacts="[[contacts]]"
                          sharing="[[mldSharedWith]]"
                          disabled="[[disabled]]"
                        ></share-job>
                        <katapult-drop-down
                          label="Select a Master Location Directory"
                          items="[[mldList]]"
                          value="{{selectedMLD}}"
                          value-path="_id"
                          label-path="name"
                        ></katapult-drop-down>
                        <katapult-button icon="person_add" color="var(--secondary-color)" on-click="openShareMLD"
                          >Edit Master Location Directory Sharing</katapult-button
                        >
                      </div>
                    </paper-header-content>
                  </template>

                  <!-- Server Access Sharing -->
                  <template
                    is="dom-if"
                    if="[[showCompanySettingsGroup('SERVER_ACCESS_SHARING', enabledFeatures.server_access_sharing, isHomeServerForCompany, isCompanyVerified)]]"
                  >
                    <server-access-manager company-id="[[companyId]]"></server-access-manager>
                  </template>

                  <!-- Attachment Records -->
                  <template
                    is="dom-if"
                    if="[[showCompanySettingsGroup('ATTACHMENT_RECORDS', enabledFeatures.admin_attachment_records, isCompanyVerified)]]"
                  >
                    <paper-header-content>
                      <paper-cell slot="header" style="cursor: pointer;">Attachment Records</paper-cell>
                      <div
                        slot="content"
                        style="display: flex; justify-content: center; padding-top: 10px; padding-bottom: 10px; flex-direction: column; padding: 1em"
                      >
                        <span style="padding-bottom: 1em; font-size: 11pt;"
                          >Agreement Number: [[displayAgreementNumber(agreementNumber)]]</span
                        >
                        <katapult-button
                          color="var(--secondary-color)"
                          on-click="generateAttachmentReport"
                          loading="[[attachmentReportLoading]]"
                        >
                          Generate Attachment Report
                        </katapult-button>
                        <template is="dom-if" if="[[attachmentReportLoading]]">
                          <span style="padding: 1em 0em; font-size: 9pt; align-self: center;"
                            ><i>Number of Attachments Recorded: [[attachmentCount]]</i></span
                          >
                        </template>
                      </div>
                    </paper-header-content>
                  </template>
                </div>

                <!-- Getting Started Box (for read only companies) -->
                <template is="dom-if" if="[[isCompanyReadOnly]]">
                  <div id="gettingStartedBox">
                    <span
                      style="text-align: center; font-size: var(--sl-font-size-large); font-weight: var(--sl-font-weight-bold); color: var(--sl-color-secondary);"
                      >Interested in full access to Katapult Pro?</span
                    >
                    <a href="https://www.katapultengineering.com/get-started" target="_blank"
                      ><katapult-button icon="rocket_launch" color="var(--sl-color-primary)">Get Started!</katapult-button></a
                    >
                  </div>
                </template>

                <template is="dom-if" if="[[showDeleteCompanyButton(systemAdmin, isHomeServerForCompany)]]">
                  <div class="buttons">
                    <katapult-button color="var(--paper-red-500)" on-click="promptDeleteCompany">Delete Company</katapult-button>
                  </div>
                </template>
                <template is="dom-if" if="[[showRemoveAccessButton(systemAdmin, isHomeServerForCompany, enabledFeatures)]]">
                  <div class="buttons">
                    <katapult-button color="var(--paper-red-500)" on-click="removeServerAccess">Remove Access</katapult-button>
                  </div>
                </template>
              </div>
            </div>

            <admin-dashboard-users-list
              companies="[[companies]]"
              company-id="[[companyId]]"
              config-options="[[configOptions]]"
              current-user-data="[[currentUserData]]"
              duration-trigger="[[durationTrigger]]"
              enabled-features="[[enabledFeatures]]"
              external-users="[[externalUsersArray]]"
              filter-string="[[searchString]]"
              selected-user-uid="[[editUserRef.uid]]"
              server-time-offset="[[serverTimeOffset]]"
              show-emails="[[showEmails]]"
              subscription="[[subscription]]"
              users="[[usersArray]]"
              user-list-metadata-attributes="[[userListMetadataAttributes]]"
              on-open-external-user-dialog="openExternalUserDialog"
              on-prompt-approve-user="promptApproveUser"
              on-prompt-deny-user="promptDenyUser"
              on-remove-external-user="removeExternalUser"
              on-select-user="selectUser"
            ></admin-dashboard-users-list>

            <div id="editUserContainer" visible$="[[exists(editUserRef.uid)]]">
              <div id="editUserHeader">
                <div class="buttons">
                  <paper-menu-button id="editUserMenu" horizontal-align="right">
                    <katapult-button icon="more_vert" iconOnly noBorder slot="dropdown-trigger"></katapult-button>
                    <div slot="dropdown-content">
                      <div style="cursor:pointer; padding: 16px;" on-click="promptChangeContactInfo">Edit Contact Info</div>
                    </div>
                  </paper-menu-button>
                </div>
                <user-chip email="[[editUserData.email]]" hide-name></user-chip>
                <span class="name">
                  <template is="dom-if" if="[[editUserData.name.first]]">
                    <span>[[editUserData.name.first]] [[editUserData.name.last]]</span>
                  </template>
                  <template is="dom-if" if="[[!editUserData.name.first]]">
                    <span style="opacity: 0.5;">Unknown</span>
                  </template>
                </span>
                <span class="email">[[editUserData.email]]</span>
              </div>
              <div class="scrollContent">
                <template is="dom-if" if="[[subscription.group_attribute]]">
                  <div class="optionRow">
                    <input-element
                      attribute_name="[[subscription.group_attribute]]"
                      model="[[getByKey(editUserCompanyAttributes, subscription.group_attribute)]]"
                      other-attributes="[[editUserCompanyAttributes]]"
                      user-group="[[userGroup]]"
                      label="[[camelCase(subscription.group_attribute)]]"
                      value="[[getByKey(editUserData, subscription.group_attribute)]]"
                      on-input-element-change="setUserSubscriptionGroup"
                      hide-attribute-name
                    ></input-element>
                  </div>
                </template>
                <!--Show inputs for editing the user metadata based on the user_metadata_attributes list in the options-->
                <template is="dom-repeat" items="[[userListMetadataAttributes]]" as="metaDataAttribute">
                  <div class="optionRow">
                    <input-element
                      attribute_name="[[metaDataAttribute.attribute]]"
                      model="[[getByKey(editUserCompanyAttributes, metaDataAttribute.attribute)]]"
                      other-attributes="[[editUserCompanyAttributes]]"
                      user-group="[[userGroup]]"
                      label="[[camelCase(metaDataAttribute.attribute)]]"
                      value="[[getByKey(editUserData.metaData, metaDataAttribute.attribute)]]"
                      on-input-element-change="setUserMetadata"
                      hide-attribute-name
                    ></input-element>
                  </div>
                </template>

                <template is="dom-if" if="[[or(currentUserData.workflows.engineering_tools, currentUserData.workflows.pole_app_portal)]]">
                  <!-- Read Permission -->
                  <div class="optionRow">
                    <div style="display: flex; align-items: center; gap: var(--sl-spacing-small); flex-grow: 1;">
                      <template is="dom-if" if="[[editUserData.read_permission]]">
                        <katapult-icon icon="visibility"></katapult-icon>
                      </template>
                      <template is="dom-if" if="[[!editUserData.read_permission]]">
                        <katapult-icon icon="visibility_off"></katapult-icon>
                      </template>
                      <div>Read Permission</div>
                    </div>
                    <paper-toggle-button
                      id="readPermissionToggle"
                      checked="[[editUserData.read_permission]]"
                      on-click="setUserReadPermission"
                    ></paper-toggle-button>
                  </div>

                  <!-- Licensed Status -->
                  <template is="dom-if" if="[[enabledFeatures.cross_server_identity]]">
                    <div class="optionRow" title="[[computeLicensedToggleTitle(isHomeServerForCompany)]]">
                      <div style="display: flex; align-items: center; gap: var(--sl-spacing-small); flex-grow: 1;">
                        <template is="dom-if" if="[[editUserData.licensed]]">
                          <katapult-icon icon="license"></katapult-icon>
                        </template>
                        <template is="dom-if" if="[[!editUserData.licensed]]">
                          <katapult-icon icon="unlicense"></katapult-icon>
                        </template>
                        <div>Licensed</div>
                      </div>
                      <paper-toggle-button
                        id="licensedToggle"
                        checked="[[editUserData.licensed]]"
                        on-click="setUserLicensedPermission"
                        disabled$="[[!isHomeServerForCompany]]"
                      ></paper-toggle-button>
                    </div>
                  </template>

                  <!-- Write Permission -->
                  <div class="optionRow">
                    <div style="display: flex; align-items: center; gap: var(--sl-spacing-small); flex-grow: 1;">
                      <template is="dom-if" if="[[editUserData.write_permission]]">
                        <katapult-icon icon="edit"></katapult-icon>
                      </template>
                      <template is="dom-if" if="[[!editUserData.write_permission]]">
                        <katapult-icon icon="edit_off"></katapult-icon>
                      </template>
                      <div>Write Permission</div>
                    </div>
                    <paper-toggle-button
                      id="writePermissionToggle"
                      checked="[[editUserData.write_permission]]"
                      on-click="setUserWritePermission"
                      disabled$="[[computeWriteToggleDisabled(enabledFeatures.cross_server_identity, editUserData.licensed)]]"
                    ></paper-toggle-button>
                  </div>

                  <!-- Company Admin -->
                  <div class="optionRow">
                    <div style="display: flex; align-items: center; gap: var(--sl-spacing-small); flex-grow: 1;">
                      <template is="dom-if" if="[[editUserData.roles.photoheight.company_admin]]">
                        <katapult-icon icon="group"></katapult-icon>
                      </template>
                      <template is="dom-if" if="[[!editUserData.roles.photoheight.company_admin]]">
                        <katapult-icon icon="group_off"></katapult-icon>
                      </template>
                      <div>Company Admin</div>
                    </div>
                    <paper-toggle-button
                      checked="[[editUserData.roles.photoheight.company_admin]]"
                      on-click="changeUserAdminStatus"
                    ></paper-toggle-button>
                  </div>

                  <div class="optionRow" style="justify-content: space-evenly;">
                    <!-- Roles -->
                    <katapult-button icon="badge" on-click="showRolesDialog">Roles</katapult-button>
                    <!-- Server Access -->
                    <template is="dom-if" if="[[isHomeServerForCompany]]">
                      <katapult-button icon="dns" on-click="showUserServerAccessDialog">Server Access</katapult-button>
                    </template>
                  </div>

                  <!-- Flex User Permission -->
                  <iron-collapse opened="[[editUserData.write_permission]]">
                    <template is="dom-if" if="[[configOptions.allow_flex_users]]">
                      <div class="optionRow">
                        <span>Flex User</span>
                        <paper-toggle-button
                          id="flexUserPermissionToggle"
                          checked="[[editUserData.flex_user]]"
                          on-click="setUserFlexPermission"
                        ></paper-toggle-button>
                      </div>
                    </template>
                  </iron-collapse>
                </template>

                <template is="dom-if" if="[[equal(userGroup, 'katapult')]]">
                  <div class="optionRow">
                    <katapult-drop-down
                      label="Employment Status"
                      items="[[employmentStatuses]]"
                      value="[[editUserData.employment_status]]"
                      value-path="$key"
                      label-path="$val"
                      show-value-as-label
                      on-selected-changed="updateUserStatus"
                      data-status="employment_status"
                    ></katapult-drop-down>
                  </div>
                  <div class="optionRow">
                    <katapult-drop-down
                      label="Employment Type"
                      items="[[employmentTypes]]"
                      value="[[editUserData.employment.employment_type]]"
                      value-path="$key"
                      label-path="$val"
                      show-value-as-label
                      on-selected-changed="updateEmployment"
                      data-attribute="employment_type"
                    ></katapult-drop-down>
                  </div>
                  <div class="optionRow">
                    <date-time-dialog
                      id="element"
                      value="[[editUserData.employment.fulltime_start_date]]"
                      on-submit="prepareFullTimeStartDateUpdate"
                      standard-time
                      label="Full Time Start Date"
                      on-value-changed="updateLocalStartDate"
                      data-attribute="fulltime_start_date"
                      invalid="[[fullTimeStartDateError]]"
                      error-message="[[fullTimeStartDateError]]"
                    >
                    </date-time-dialog>
                  </div>
                  <div class="optionRow">
                    <katapult-drop-down
                      label="Timesheet Submission Status"
                      items="[[timesheetStatuses]]"
                      value="[[editUserData.timesheet_submission_status]]"
                      value-path="$key"
                      label-path="$val"
                      show-value-as-label
                      on-selected-changed="updateUserStatus"
                      data-status="timesheet_submission_status"
                    ></katapult-drop-down>
                  </div>
                  <div class="optionRow">
                    <paper-checkbox
                      checked="[[editUserData.employment.overhead_employee]]"
                      data-attribute="overhead_employee"
                      on-checked-changed="updateEmployment"
                      >Overhead Employee</paper-checkbox
                    >
                  </div>
                  <div class="optionRow">
                    <paper-checkbox
                      checked="[[editUserData.employment.overhead_employee]]"
                      data-attribute="salaried"
                      on-checked-changed="updateEmployment"
                      >Salaried</paper-checkbox
                    >
                  </div>
                </template>
                <template is="dom-if" if="[[enabledFeatures.project_manager_role]]">
                  <div class="optionRow">
                    <span>Project Manager</span>
                    <paper-toggle-button
                      checked="[[editUserData.roles.photoheight.project_manager]]"
                      on-click="changeUserProjectManagerStatus"
                    ></paper-toggle-button>
                  </div>
                </template>
                <template
                  is="dom-if"
                  if="[[calcShowPortalAdmin(companyId, currentUserData.workflows.pole_app_portal, config.firebaseData.utilityCompany, isPortalAdmin)]]"
                >
                  <div class="optionRow">
                    <span>Portal Admin</span>
                    <paper-toggle-button
                      checked="[[editUserData.roles.pole_app_portal.pole_app_portal_admin]]"
                      on-click="changeUserPoleAppPortalAdminStatus"
                    ></paper-toggle-button>
                  </div>
                </template>
                <template is="dom-if" if="[[showResetPasswordOption(companySignInOptions.email)]]">
                  <div class="optionRow">
                    <span>Reset Password</span>
                    <katapult-button icon="restore" iconOnly noBorder callback="promptResetPassword"></katapult-button>
                  </div>
                </template>
              </div>
              <div class="buttons">
                <template is="dom-if" if="[[isHomeServerForCompany]]">
                  <katapult-button color="var(--paper-red-500)" on-click="promptDeleteUser">Delete</katapult-button>
                </template>
                <katapult-button on-click="clearEditUserRef">Close</katapult-button>
              </div>
            </div>
          </div>
        </div>
      </katapult-auth>
    `;
  }

  static get is() {
    return 'admin-dashboard';
  }
  static get properties() {
    return {
      additionalLicenses: {
        type: Number,
        value: 0
      },
      companyId: {
        type: String
      },
      companySignInOptions: {
        type: Object,
        value: () => ({})
      },
      currentUserData: {
        type: Object,
        value: () => ({})
      },
      deleteCompanyErrorMessage: {
        type: String,
        value: null
      },
      deleteUserErrorMessage: {
        type: String,
        value: null
      },
      editUserData: {
        type: Object
      },
      employmentStatuses: {
        type: Object,
        value: () => ({
          active: 'Active',
          inactive: 'Inactive'
        })
      },
      timesheetStatuses: {
        type: Object,
        value: () => ({
          weekly: 'Weekly',
          sporadic: 'Sporadic'
        })
      },
      employmentTypes: {
        type: Object,
        value: () => ({
          regular: 'Benefited',
          'non-benefited': 'Non-Benefited'
        })
      },
      enabledFeatures: {
        type: Object,
        value: () => ({})
      },
      isPortalAdmin: {
        type: Boolean,
        computed: 'computePortalAdminStatus(currentUserData)'
      },
      numLicensedUsers: {
        type: Number,
        value: 0
      },
      usersArray: {
        type: Array,
        value: []
      },
      userListMetadataAttributes: {
        type: Array,
        computed: 'computeUserListMetadataAttributes(configOptions.user_metadata_attributes)'
      },
      address: {
        type: Object,
        value: {}
      },
      sharingCompanyNames: {
        type: Object,
        value: {}
      },
      showEmails: {
        type: Boolean,
        value: true
      },
      signedIn: {
        type: Boolean,
        value: false
      },
      companyHomeServer: {
        type: String,
        value: null
      },
      companyHomeServerName: {
        type: String,
        computed: 'computeHomeServerName(config.serverNames, companyHomeServer)'
      },
      isHomeServerForCompany: {
        type: Boolean,
        computed: 'computeIsHomeServerForCompany(companyHomeServer, config.appName, enabledFeatures.limit_admin_actions_to_home_server)'
      },
      isCompanyVerified: {
        type: Boolean,
        computed: 'computeIsCompanyVerified(companyId, companies)'
      },
      isCompanyReadOnly: {
        type: Boolean,
        computed: 'computeIsCompanyReadOnly(subscription.count)'
      },
      creatingUsersLockedForTransfer: {
        type: Boolean,
        value: false
      },
      requestAttachments: {
        type: Array,
        value: []
      }
    };
  }
  static get observers() {
    return [
      'companyIdChanged(companyId, userGroup, systemAdmin)',
      'defaultCompanyId(systemAdmin, userGroup)',
      'computeUsersArray(user, currentUserData, canReadAllUsers, companyUsers.*, users.*)',
      'computeCompaniesArray(userGroup, canReadAllUsers, companiesFromUsers, companies, companyId)',
      'calcLicenseTotals(subscription.count, additionalLicenses, subscription.subscriptionItem)',
      'calcNumLicensedUsers(companyId, companyNumLicensedUsers.*, subscription.group_attribute)',
      'setSelectedEndpoint(configOptions.endpoints)',
      'updateMLDListListener(userGroup)',
      'mldSelected(selectedMLD)',
      'computeCanReadWriteFlags(userRoles, systemAdmin, isAdmin, companyId, userGroup)',
      'computeShowEmails(configOptions.hide_email)',
      'userGroupSpecificSettings(userGroup)',
      'updateUserRolesListener(user.uid)',
      'getAgreementNumber(enabledFeatures.admin_attachment_records, companyId)',
      'computeExternalUsersArray(companyExternalUsers.*)',
      'updateCompanyUsersRolesListener(companyId, isAdmin)',
      'updateTransferLockingListener(userGroup)'
    ];
  }
  constructor() {
    super();
    this.subscription = null;
  }
  ready() {
    super.ready();

    const dataLoadedCallback = (config) => {
      const bannerConfig = config.firebaseData?.admin_dashboard_banner;
      if (!bannerConfig) return;
      KatapultBanner.createBanner('white-label-admin-banner', bannerConfig);
    };
    const appConfigurationOptions = { dataLoaded: dataLoadedCallback };
    this.appConfiguration = new AppConfiguration(this, appConfigurationOptions);
    this.createUserWorkflowsError = '';
    this.userRoles = null;
  }

  connectedCallback() {
    super.connectedCallback();

    // Set an interval to update Davey users' last active time every second
    if (this.userGroup == 'davey_resource_group_inc')
      this.durationIntervalId = setInterval(() => (this.durationTrigger = !this.durationTrigger), 1000);

    // Set up the feature flag listeners
    this.crossServerJobSharingFlagListener = addFlagListener('cross_server_job_sharing', (enabled) => {
      this.set('enabledFeatures.cross_server_job_sharing', enabled);
    });

    this.projectManagerRoleFlagListener = addFlagListener('project_manager_role', (enabled) => {
      this.set('enabledFeatures.project_manager_role', enabled);
    });

    this.masterLocationDirectorySharingFlagListener = addFlagListener('master_location_directory_sharing', (enabled) => {
      this.set('enabledFeatures.master_location_directory_sharing', enabled);
    });

    this.signInMethodsFlagListener = addFlagListener('sign_in_methods', (enabled) => {
      this.set('enabledFeatures.sign_in_methods', enabled);
    });

    this.signInMethodEmailFlagListener = addFlagListener('sign_in_method_email', (enabled) => {
      this.set('enabledFeatures.sign_in_method_email', enabled);
    });

    this.signInMethodGoogleFlagListener = addFlagListener('sign_in_method_google', (enabled) => {
      this.set('enabledFeatures.sign_in_method_google', enabled);
    });

    this.signInMethodMicrosoftFlagListener = addFlagListener('sign_in_method_microsoft', (enabled) => {
      this.set('enabledFeatures.sign_in_method_microsoft', enabled);
    });

    this.signInMethodEnterpriseSSOFlagListener = addFlagListener('sign_in_method_enterprise_sso', (enabled) => {
      this.set('enabledFeatures.sign_in_method_enterprise_sso', enabled);
    });

    this.jobLockingFlagListener = addFlagListener('job_locking', (enabled) => {
      this.set('enabledFeatures.job_locking', enabled);
    });

    this.serverAccessSharingFlagListener = addFlagListener('server_access_sharing', (enabled) => {
      this.set('enabledFeatures.server_access_sharing', enabled);
    });

    this.limitAdminActionsToHomeServerFlagListener = addFlagListener('limit_admin_actions_to_home_server', (enabled) => {
      this.set('enabledFeatures.limit_admin_actions_to_home_server', enabled);
    });

    this.showAttachmentRecordsFlagListener = addFlagListener('admin_attachment_records', (enabled) => {
      this.set('enabledFeatures.admin_attachment_records', enabled);
    });

    this.exportAllUserDataFlagListener = addFlagListener('export_all_user_data', (enabled) => {
      this.set('enabledFeatures.export_all_user_data', enabled);
    });

    this.canShareServerAccessFlagListener = addFlagListener('can_share_server_access', (enabled) => {
      this.set('enabledFeatures.can_share_server_access', enabled);
    });

    this.exportCrossServerUserPermissionsFlagListener = addFlagListener('cross_server_user_permissions', (enabled) => {
      this.set('enabledFeatures.cross_server_user_permissions', enabled);
    });

    this.crossServerIdentityFlagListener = addFlagListener('cross_server_identity', (enabled) => {
      this.set('enabledFeatures.cross_server_identity', enabled);
    });

    this.userDeactivationListener = addFlagListener('deactivate_users', (enabled) => {
      this.set('enabledFeatures.deactivate_users', enabled);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    clearInterval(this.durationIntervalId);

    // Remove the feature flag listeners
    removeFlagListener('cross_server_job_sharing', this.crossServerJobSharingFlagListener);
    removeFlagListener('project_manager_role', this.projectManagerRoleFlagListener);
    removeFlagListener('master_location_directory_sharing', this.masterLocationDirectorySharingFlagListener);
    removeFlagListener('sign_in_methods', this.signInMethodsFlagListener);
    removeFlagListener('sign_in_method_email', this.signInMethodEmailFlagListener);
    removeFlagListener('sign_in_method_google', this.signInMethodGoogleFlagListener);
    removeFlagListener('sign_in_method_microsoft', this.signInMethodMicrosoftFlagListener);
    removeFlagListener('sign_in_method_enterprise_sso', this.signInMethodEnterpriseSSOFlagListener);
    removeFlagListener('job_locking', this.jobLockingFlagListener);
    removeFlagListener('server_access_sharing', this.serverAccessSharingFlagListener);
    removeFlagListener('limit_admin_actions_to_home_server', this.limitAdminActionsToHomeServerFlagListener);
    removeFlagListener('admin_attachment_records', this.showAttachmentRecordsFlagListener);
    removeFlagListener('export_all_user_data', this.exportAllUserDataFlagListener);
    removeFlagListener('can_share_server_access', this.canShareServerAccessFlagListener);
    removeFlagListener('cross_server_user_permissions', this.exportCrossServerUserPermissionsFlagListener);
    removeFlagListener('cross_server_identity', this.crossServerIdentityFlagListener);
    removeFlagListener('deactivate_users', this.userDeactivationListener);
    this.disconnectUserRolesListener?.();
    this.disconnectTransferLockingListener?.();
  }

  updateUserRolesListener(uid) {
    this.disconnectUserRolesListener?.();
    if (!uid) return;
    this.disconnectUserRolesListener = ListenToUserRoles(uid, (roles) => (this.userRoles = roles));
  }

  updateTransferLockingListener(userGroup) {
    this.disconnectTransferLockingListener?.();
    if (!userGroup) return;

    this.disconnectTransferLockingListener = listenToTransferLocking(userGroup, (transferLocking) => {
      this.creatingUsersLockedForTransfer = transferLocking?.lock_creating_users;
    });
  }

  showCompanySettingsGroup(groupName) {
    switch (groupName) {
      case 'VERIFICATION':
        return !this.isCompanyVerified;
      case 'SUBSCRIPTION_AND_BILLING':
        return (
          this.subscription != null && this.subscription?.count != 'Unlimited' && this.isHomeServerForCompany && this.isCompanyVerified
        );
      case 'PORTAL_COMPANY_SETTINGS':
        return this.currentUserData?.workflows?.pole_app_portal && this.isCompanyVerified;
      case 'AUTH_OPTIONS':
        return this.isAdmin && this.isHomeServerForCompany;
      case 'GOOGLE_DRIVE':
        return this.userGroup == 'katapult' && this.isHomeServerForCompany && this.isCompanyVerified;
      case 'CROSS_SERVER_JOB_SHARING':
        return this.enabledFeatures?.cross_server_job_sharing && this.isCompanyVerified;
      case 'MLD_SHARING':
        return this.enabledFeatures?.master_location_directory_sharing && this.isCompanyVerified;
      case 'SERVER_ACCESS_SHARING':
        return this.enabledFeatures?.server_access_sharing && this.isHomeServerForCompany && this.isCompanyVerified;
      case 'ATTACHMENT_RECORDS':
        return this.enabledFeatures?.admin_attachment_records && this.isCompanyVerified;
      default:
        return false;
    }
  }
  and(a, b) {
    return a && b;
  }
  or(a, b) {
    return a || b;
  }
  equal(a, b) {
    return a == b;
  }
  toArray(obj) {
    return ToArray(obj);
  }
  async openExternalUserDialog(e) {
    const { user } = e.detail;
    const { _id: uid } = user;
    if (this.externalUserDialog) return;
    const serverHasPortal = this.currentUserData?.workflows?.pole_app_portal === true;
    const dialog = (this.externalUserDialog ??= new ExternalUserDialog(this.companyId, uid, { serverHasPortal }));
    this.shadowRoot?.appendChild(dialog);
    await dialog.updateComplete;
    dialog.dialog.closeComplete.then(() => {
      this.shadowRoot?.removeChild(dialog);
      this.externalUserDialog = null;
    });
  }
  async calcLicenseTotals() {
    this.newTotalLicenses = this.get('subscription.count') + Number(this.additionalLicenses);
    this.licenseCost = await FirebaseWorker.ref('photoheight/white_label/license_cost')
      .once('value')
      .then((s) => s.val());

    this.additionalLicenseCost = Number(this.additionalLicenses) * this.licenseCost;
  }
  calcNumLicensedUsers() {
    this.numLicensedUsers = this.get(`companyNumLicensedUsers.${this.companyId}`) ?? 0;
    if (this.get('subscription.group_attribute')) {
      let temp = {};
      for (let uid in this.companyUsers) {
        let groupAttributeValue = this.get(`companyUsers.${uid}.${this.get('subscription.group_attribute')}`);
        if (groupAttributeValue == null || groupAttributeValue == '') groupAttributeValue = 'Other';
        // If we have CSI enabled, check the number of licensed users for each company, rather than number of write users
        const licenseKey = this.enabledFeatures?.cross_server_identity === true ? 'licensed' : 'write_permission';
        if (this.get(`companyUsers.${uid}.${licenseKey}`)) {
          temp[groupAttributeValue] = temp[groupAttributeValue] || 0;
          temp[groupAttributeValue]++;
        }
      }
      this.licenseGroups = ToArray(temp);
    }
  }
  getFilteredUsers() {
    const usersListElement = this.shadowRoot?.querySelector('admin-dashboard-users-list');
    if (!usersListElement) return [];
    const filteredUsers = usersListElement.getFilteredUsers();
    return filteredUsers;
  }
  camelCase(x) {
    return CamelCase(x);
  }
  async changeUserAdminStatus(e) {
    e.currentTarget.checked = !e.currentTarget.checked;
    this.changeUserAdminStatusTarget = this.editUserData;
    this.changeUserAdminStatusTarget.uid = this.editUserRef.uid;
    this.changeUserAdminStatusTarget.companyId = this.editUserRef.companyId;
    if (this.editUserRef.uid == this.user.uid && e.currentTarget.checked) this.$.removeYourAdminPermissionDialog.open();
    else {
      let toggle = e.currentTarget;
      toggle.disabled = true;
      await this.confirmChangeUserAdminStatus();
      toggle.disabled = false;
    }
  }

  async changeUserProjectManagerStatus(e) {
    // if it's not checked, we want to remove the project_manager property
    let projectManagerVal = e.currentTarget.checked;
    if (e.currentTarget.checked === false) projectManagerVal = null;

    let update = {};
    // update role in user list for company
    update[`photoheight/company_space/${this.userGroup}/users/${this.editUserRef.uid}/project_manager`] = projectManagerVal;
    // update role on user
    update[`users/${this.userGroup}/${this.editUserRef.uid}/roles/photoheight/project_manager`] = projectManagerVal;
    await FirebaseWorker.ref().update(update);
  }

  async changeUserPoleAppPortalAdminStatus(e) {
    e.currentTarget.checked = !e.currentTarget.checked;
    const toggle = e.currentTarget;

    const isPortalAdmin = !this.get('editUserData.roles.pole_app_portal.pole_app_portal_admin');
    const { uid, companyId: userCompany } = this.editUserRef ?? {};
    const utilityCompany = this.get('config.firebaseData.utilityCompany');
    if (!uid || !userCompany || !utilityCompany) throw Error('Failed to set portal admin status.  Missing user or company data.');

    toggle.disabled = true;
    try {
      await SetUserRole(uid, 'portal_configuration_write', utilityCompany, isPortalAdmin);
      const poleAppPortalAdminRef = globalThis.FirebaseWorker.ref(
        `users/${userCompany}/${uid}/roles/pole_app_portal/pole_app_portal_admin`
      );
      await poleAppPortalAdminRef.set(isPortalAdmin);
    } finally {
      toggle.disabled = false;
    }
  }

  computeCanReadWriteFlags() {
    if (!this.userRoles) return;

    const allCompanyRoles = this.userRoles.__all__;
    const systemAdmin = this.systemAdmin;
    const companyAdmin = this.companyId == this.userGroup && this.isAdmin;

    this.canReadAllUsers = allCompanyRoles?.users_read === true || systemAdmin;
    this.canWriteAllUsers = allCompanyRoles?.users_write === true || systemAdmin;
    this.hasUniversalSubmissionRole = allCompanyRoles?.portal_company_submission_options_write === true || systemAdmin;
    this.canWriteCompanySubmissionOptions = this.hasUniversalSubmissionRole || companyAdmin;
    this.canWriteMrNotificationInfo = allCompanyRoles?.company_contact_info_mr_notification_write === true || companyAdmin || systemAdmin;
  }

  showResetPasswordOption(email) {
    return email !== false;
  }
  clearEditUserRef() {
    this.editUserRef = null;
  }
  showRolesDialog() {
    /** @type {KatapultDialog} */ (this.$.rolesDialog).open();
  }
  showUserServerAccessDialog() {
    this.shadowRoot?.querySelector('#userServerAccessDialog')?.open();
  }
  changePermissionFlag(e) {
    let checked = e.currentTarget?.checked ?? e.checked;
    let dataset = e.currentTarget?.dataset ?? e.dataset;
    if (dataset?.flag) {
      // If the user is given write access, also give read
      if (dataset?.flag == 'model_editor_write_access' && checked == true) {
        this.changePermissionFlag({
          checked: true,
          dataset: { flag: 'model_editor_read_access' }
        });
      }
      FirebaseWorker.ref(`users/${this.editUserRef.companyId}/${this.editUserRef.uid}/roles/photoheight/permissions/${dataset?.flag}`).set(
        checked
      );
    }
  }
  companyIdChanged() {
    if (!this.canReadAllUsers && this.companyId != this.userGroup) this.companyId = this.userGroup;

    // If the companyId is an empty string and the user is a system admin, load all users
    if (this.canReadAllUsers && this.companyId == '' && !this.throttledLoadAllUsers) {
      this.throttledLoadAllUsers = Throttle((s) => {
        this.set('users', s.val());
      }, 750);
      this.unsubscribeUsersListener = FirebaseWorker.ref('users').on('value', this.throttledLoadAllUsers);
    } else {
      FirebaseWorker.ref('users').off('value', this.unsubscribeUsersListener);
    }
  }
  computeCompaniesArray() {
    if (!this.companiesFromUsers || !this.companiesFromAllUsers) return;
    if (this.canReadAllUsers) {
      this.companiesArray = ToArray(this.companies).filter(
        (company) => this.companiesFromUsers[company.$key] || !this.companiesFromAllUsers[company.$key]
      );
      if (this.companyId && !this.companiesArray.find((company) => company.$key == this.companyId)) this.companyId = null;
    } else {
      this.companiesArray = [{ name: this.get(`companies.${this.userGroup}.name`), $key: this.userGroup }];
    }
  }
  computeUsersArray() {
    if (this.user && this.userGroup) {
      let temp = [];
      let companyNumLicensedUsers = {};
      let users = {};

      // If all users are not loaded, still make companyUsers match the format of /users.
      if (!this.users || !this.canReadAllUsers) users[this.companyId] = this.companyUsers;
      else users = this.users;

      // Now loop through the companies and their users storing the companyId and uid for each user.
      for (let companyId in users) {
        for (let uid in users[companyId]) {
          let user = users[companyId][uid];
          if (companyNumLicensedUsers[companyId] == null) companyNumLicensedUsers[companyId] = 0;
          // If we have CSI enabled, check the number of licensed users for each company, rather than number of write users
          if (this.enabledFeatures?.cross_server_identity === true) {
            if (user.licensed) companyNumLicensedUsers[companyId]++;
          } else {
            if (user.write_permission) companyNumLicensedUsers[companyId]++;
          }
          temp.push(Object.assign(user, { uid, companyId }));
        }
      }

      this.companyNumLicensedUsers = companyNumLicensedUsers;

      // At this point, temp has all users that exist in the system (if currentUser is a system admin, otherwise, it's just the currentUsers's company's users).
      // Create a list of companies which have users in them based off of temp.
      let companiesFromAllUsers = {};
      temp.forEach((user) => (companiesFromAllUsers[user.companyId] = true));
      this.companiesFromAllUsers = companiesFromAllUsers;

      // Filter temp down to only contain users which currentUser has permission to view due to overlapping permissions or are part of their company.
      if (!this.canReadAllUsers) {
        temp = temp.filter(
          (user) =>
            user.companyId == this.userGroup ||
            ['pole_app_portal', 'tsl_maps', 'engineering_tools'].some(
              (x) => Path.get(user, `workflows.${x}`) && this.currentUserData.workflows?.[x]
            )
        );
      }

      // Create a new list of companies with users that currentUser may see.
      let companiesFromUsers = {};
      temp.forEach((user) => (companiesFromUsers[user.companyId] = true));
      this.companiesFromUsers = companiesFromUsers;

      // Compute the companiesArray based off of the companiesFromAllUsers and companiesFromUsers.
      this.computeCompaniesArray();

      // If a specific company is selected, filter temp to only contain those users.
      if (this.companyId) temp = temp.filter((user) => user.companyId == this.companyId);

      this.usersArray = temp;

      if (this.editUserRef && !this.usersArray.find((user) => user.uid == this.editUserRef.uid)) this.clearEditUserRef();
    }
  }
  computeExternalUsersArray() {
    const companyExternalUsers = this.companyExternalUsers ?? {};
    const companyExternalUsersEntries = Object.entries(companyExternalUsers);
    const companyExternalUsersArray = companyExternalUsersEntries.map(([_id, user]) => ({ ...user, _id }));
    this.externalUsersArray = companyExternalUsersArray;
  }
  calcDuration(lastChanged) {
    if (lastChanged) {
      let x = HowLong(Date.now() + this.serverTimeOffset - lastChanged);
      return x[0];
    }
  }
  formatDate(timestamp) {
    return FormatDate(timestamp);
  }
  async confirmAddLicense() {
    let addresses = 'katapultpro-licenses@katapultengineering.com';
    let additionalLicenses = Number(this.additionalLicenses);
    let totalLicenses = this.newTotalLicenses;
    if (additionalLicenses > 0 && totalLicenses > 0) {
      this.addingLicenses = true;
      await ServerRequest('change_subscription', {
        count: this.newTotalLicenses,
        subscription_item_id: this.get('subscription.subscription_item_id') || null,
        stripe_id: this.get('subscription.stripe_id') || null,
        userGroup: this.userGroup
      })
        .then(async () => {
          let body = `${this.user.email} has added ${additionalLicenses} more license${this.s(
            additionalLicenses
          )} to ${this.getCompanyName(this.companyId)}. They now have ${totalLicenses} license${this.s(totalLicenses)}.`;
          await ServerRequest('email', { addresses, subject: 'Request for more licenses', body, group_tag: 'internal' });
        })
        .catch(async (err) => {
          let body = `${this.user.email} tried to add ${additionalLicenses} more license${this.s(
            additionalLicenses
          )} to ${this.getCompanyName(this.companyId)}. This operation failed with an error of: ${err.message}`;
          await ServerRequest('email', {
            addresses: ['support@katapultengineering.com'],
            subject: 'Failure to Update License Count',
            body,
            group_tag: 'internal'
          })
            .then(() => {
              this.$.addLicenseErrorDialog.open();
              let message = 'Failed to Update License Count';
              if (err.message) message += ': ' + err.message;
              this.toast(message);
            })
            .catch((e) => {
              let message = 'Failed to Update License Count; Please Contact Katapult';
              if (err.message) message += ': ' + err.message;
              this.toast(message);
            });
        });
      this.additionalLicenses = 0;
      this.addingLicenses = false;
      this.$.confirmAddLicenseDialog.close();
    } else {
      console.warn(`Additional license count must be greater than 0 (${additionalLicenses} were requested)`);
    }
  }
  async confirmApproveUser() {
    if (this.approveUserTarget) {
      this.approvingUser = true;
      let update = {};
      update[`users/${this.approveUserTarget.companyId}/${this.approveUserTarget.uid}/pending_permission`] = false;
      update[`user_groups/${this.approveUserTarget.uid}/individual_permissions/${this.approveUserTarget.companyId}/read`] = true;
      await FirebaseWorker.ref().update(update);
      let body = [
        `${this.approveUserTarget.email},`,
        '',
        `You have been approved to join ${this.getCompanyName(this.approveUserTarget.companyId)}.`,
        '',
        `Get started using ${config.firebaseData.name} ${config.firebaseData.homePageName ?? ''}: ${globalThis.config?.firebaseData?.origin_url ?? location.origin}/${config.firebaseData.homePage ?? ''}`,
        '',
        `If you have any questions, please contact us at ${config.firebaseData.contactEmail}`,
        '',
        'Thanks!',
        '',
        config.firebaseData.name
      ].join('\n');
      // await ServerRequest('email', {addresses: [this.approveUserTarget.email], subject: `You have been approved to join ${this.getCompanyName(this.approveUserTarget.companyId)}`, body});
      // See if this user requested to have their company submit on behalf of another company.
      await FirebaseWorker.ref(
        `users/${this.approveUserTarget.companyId}/${this.approveUserTarget.uid}/metaData/requested_attacher_company`
      )
        .once('value')
        .then(async (s) => {
          let attacherRequest = s.val();
          if (attacherRequest && attacherRequest.attacher) {
            let request = {
              companyId: this.approveUserTarget.companyId,
              attacher: attacherRequest.attacher,
              add_attacher: attacherRequest.add_attacher || false
            };
            await firebase
              .functions()
              .httpsCallable('requestSubmitFor')(request)
              .catch((e) => {
                if (e.code !== 'already-exists') throw e;
              });
            await s.ref.remove();
          }
        });
      this.approvingUser = false;
      this.$.approveUserDialog.close();
      this.editUserRef = this.approveUserTarget;
      this.approveUserTarget = null;
    } else throw 'Missing Approve User Target';
  }
  async confirmChangeUserAdminStatus() {
    if (this.changeUserAdminStatusTarget) {
      await SetUserCompanyAdmin(
        this.changeUserAdminStatusTarget.uid,
        this.changeUserAdminStatusTarget.companyId,
        !this.changeUserAdminStatusTarget.roles.photoheight.company_admin
      );
      this.changeUserAdminStatusTarget = null;
    } else throw 'Missing Change User Admin Status Target';
  }
  async confirmCreateUser() {
    const emailInput = /** @type {PaperInputElement} */ (this.$.createUserEmailInput);
    const companyInput = /** @type {PaperInputElement} */ (this.$.createUserCompanyInput);
    emailInput.invalid = companyInput.invalid = false;
    this.createUserWorkflowsError = '';

    // If the user is not a system admin, they can only create users for their active company.
    if (!this.canWriteAllUsers) this.createUserCompanyId = this.userGroup;

    const sanitizedEmail = (this.createUserEmail || '').trim();
    const emailInvalid = !/^.+@.+\..+$/.test(sanitizedEmail);
    if (!sanitizedEmail) {
      emailInput.errorMessage = 'Email is required';
      emailInput.invalid = true;
    } else if (emailInvalid) {
      emailInput.errorMessage = 'Valid email is required';
      emailInput.invalid = true;
    }

    if (!this.createUserCompanyId) {
      companyInput.errorMessage = 'Company is required';
      companyInput.invalid = true;
    }

    const hasWorkflowOptionsAndNoneSelected = this.showCreateUserWorkflows && this.createUserWorkflows.every((x) => !x.$val);
    if (hasWorkflowOptionsAndNoneSelected) this.createUserWorkflowsError = 'You must choose at least one workflow for this user';

    // If we encountered any errors, return early
    if (!sanitizedEmail || emailInvalid || !this.createUserCompanyId || hasWorkflowOptionsAndNoneSelected) return;

    const preferences = this.get('config.firebaseData.utilityCompany') ? { poleAppPortalEmailNotifications: true } : null;
    this.creatingUser = true;

    // Build the workflows object
    const workflows = {};
    this.createUserWorkflows.filter((x) => x.$val).forEach((x) => (workflows[x.$key] = true));

    // Build the roles object
    const companyRolesCheckboxes =
      /** @type {NodeListOf<PaperCheckboxElement>|undefined} */ (
        this.shadowRoot?.querySelectorAll('#createUserDialog .create-user-role-option')
      ) ?? [];
    const checkedCompanyRolesCheckboxes = Array.from(companyRolesCheckboxes).filter((checkbox) => checkbox.checked);
    const companyRoles = checkedCompanyRolesCheckboxes.map((checkbox) => checkbox.dataset.userRole);

    let path = '';
    if (workflows.tsl_maps) path = '/tsl-maps-generator';
    if (workflows.pole_app_portal) path = '/pole-application-overview';
    if (workflows.engineering_tools) path = '/map';

    try {
      await ServerRequest('create_user', {
        email: sanitizedEmail,
        companyId: this.createUserCompanyId,
        preferences,
        url: (globalThis.config?.firebaseData?.origin_url ?? location.origin) + path,
        canRead: true,
        isWriteUser: Boolean(this.isWriteUser),
        isAdmin: Boolean(this.isCompanyAdmin),
        companyRoles,
        workflows
      });

      /** @type {PaperDialogElement} */ (this.$.createUserDialog).close();
      const userRecord = this.usersArray.find((x) => x.email == sanitizedEmail);
      if (userRecord) this.editUserRef = userRecord;
    } catch (error) {
      emailInput.errorMessage = error.message;
      emailInput.invalid = true;
    } finally {
      this.creatingUser = false;
    }
  }

  async confirmCreateCompany() {
    this.$.createCompanyNameInput.invalid = false;
    let sanitizedCompanyName = (this.createCompanyName || '').trim();
    if (!sanitizedCompanyName) {
      this.$.createCompanyNameInput.errorMessage = 'Company name is required';
      this.$.createCompanyNameInput.invalid = true;
    } else {
      // Check to see if cross server identity is enabled
      const crossServerIdentityIsEnabled = await _checkCrossServerIdentity(globalThis.firebase.database());
      let companyId = NameToKey(sanitizedCompanyName);
      let alreadyExists =
        crossServerIdentityIsEnabled === true
          ? await checkIfCompanyIdInUse(globalThis.firebase, companyId)
          : this.get(`companies.${companyId}`) != null;
      if (alreadyExists) {
        this.$.createCompanyNameInput.errorMessage = 'Company already exists';
        this.$.createCompanyNameInput.invalid = true;
      } else {
        this.creatingCompany = true;
        let update = {};
        // Loop through keys of company_space data and set each so as to not overwrite any existing data (for pole app portal, there could be attach requests before the company is requested).
        let companySpace = {
          name: sanitizedCompanyName,
          subscription: {
            count: 0
          }
        };
        for (let key in companySpace) update[`company_space/${companyId}/${key}`] = companySpace[key];
        update[`company_space/${this.userGroup}/contacts/${companyId}`] = true;
        update[`companies/${companyId}`] = { name: sanitizedCompanyName };
        update[`company_space/${companyId}/home_server`] = config.appName;
        await FirebaseWorker.ref('photoheight')
          .update(update)
          .then(() => {
            this.$.createCompanyDialog.close();
            this.companyId = companyId;
          })
          .catch((e) => {
            this.createCompanyNameInput.errorMessage = 'You do not have permission to create companies';
            this.createCompanyNameInput.invalid = true;
          })
          .finally(() => {
            this.creatingCompany = false;
            this.createCompanyName = '';
          });
        if (crossServerIdentityIsEnabled === true) {
          await CallCrossServerIdentityAction(globalThis.firebase.auth(), 'ADD_COMPANY_RECORD', {
            serverId: globalThis.config.appName,
            companyId
          }).catch(async (error) => {
            // Delete the company if the cross server identity action fails
            for (let key in update) update[key] = null;
            await FirebaseWorker.ref('photoheight').update(update);
            throw error;
          });
        }
      }
    }
  }
  async confirmDeleteCompany() {
    let userCompanies = await firebase
      .database()
      .ref(`user_groups/${this.user.uid}/individual_permissions`)
      .once('value')
      .then((s) => s.val());
    let userCoPermissions = Object.keys(userCompanies || {});
    let found = false;
    for (let i = 0; i < userCoPermissions.length; i++) {
      if (userCoPermissions[i] == this.companyId) {
        found = true;
      }
    }
    if (found) {
      let userList = await FirebaseWorker.ref(`user_groups`)
        .once('value')
        .then((s) => s.val());
      let userKey = Object.keys(userList || {});
      for (let j = 0; j < userKey.length; j++) {
        let userPermissions = await FirebaseWorker.ref(`user_groups/${userKey[j]}/individual_permissions`)
          .once('value')
          .then((s) => s.val());
        let keys = Object.keys(userPermissions || {});
        for (let i = 0; i < keys.length; i++) {
          if (keys[i] == this.companyId) {
            await firebase.database().ref(`user_groups/${userKey[j]}/individual_permissions/${this.companyId}`).remove();
          }
        }
      }
    }
    console.log(`Deleting company ${this.companyId}...`);
    this.deletingCompany = true;
    await firebase
      .functions()
      .httpsCallable('deleteCompany', { timeout: 600000 })({ companyId: this.companyId })
      .then((results) => {
        this.$.deleteCompanyDialog.close();
        this.companyId = null;
      })
      .catch((err) => {
        console.log(err);
        this.deleteCompanyErrorMessage = err;
      });
    this.deletingCompany = false;
  }
  async confirmDeleteUser() {
    if (this.deleteUserTarget) {
      this.deletingUser = true;
      await firebase
        .functions()
        .httpsCallable('deleteUser')({ uid: this.deleteUserTarget.uid })
        .then((results) => {
          this.$.deleteUserDialog.close();
          this.editUserRef = null;
          this.deleteUserTarget = null;
        })
        .catch((err) => {
          console.error(err);
          this.deleteUserErrorMessage = err.message;
        });
      this.deletingUser = false;
    } else throw 'Missing Delete User Target';
  }
  async confirmDenyUser() {
    if (this.denyUserTarget) {
      this.denyingUser = true;
      this.deleteUserTarget = this.denyUserTarget;
      await this.confirmDeleteUser();
      let body = [
        `${this.denyUserTarget.email},`,
        '',
        `Your request to join ${this.getCompanyName(this.denyUserTarget.companyId)} has been denied.`,
        '',
        `If you have any questions, please contact us at ${config.firebaseData.contactEmail}`,
        '',
        'Thanks!',
        '',
        config.firebaseData.name
      ].join('\n');
      // await ServerRequest('email', {addresses: [this.denyUserTarget.email], subject: `Your request to join ${this.getCompanyName(this.denyUserTarget.companyId)} has been denied`, body});
      this.denyingUser = false;
      this.$.denyUserDialog.close();
      this.denyUserTarget = null;
    } else throw 'Missing Deny User Target';
  }
  async confirmEditContactInfo() {
    this.editContactInfoSaving = true;
    await this.$.katapultContactInfo.saveContactInfo();
    this.editContactInfoSaving = false;
    this.$.editContactInfoDialog.close();
  }
  async confirmResetPassword() {
    if (this.resetPasswordTarget) {
      this.resettingPassword = true;
      await firebase.functions().httpsCallable('sendPasswordResetEmail')({
        email: this.resetPasswordTarget.email,
        url: `${window.location.origin}/${this.get('config.firebaseData.homePage') || 'map'}`
      });
      this.resettingPassword = false;
      this.$.resetPasswordDialog.close();
      this.resetPasswordTarget = null;
    } else throw 'Missing Reset Password Target';
  }
  defaultCompanyId() {
    if (this.userGroup && this.companyId !== this.userGroup && (!this.canReadAllUsers || this.companyId === undefined))
      this.companyId = this.userGroup;
  }
  exists() {
    return Array.from(arguments).every((x) => this._exists(x));
  }
  _exists(x) {
    return x != null && x != '';
  }
  getByKey(x, key) {
    if (x != null) return x[key];
  }
  getCompanyName(companyId) {
    return this.get(`companies.${companyId}.name`);
  }
  calcRemainingHours(total, used) {
    return Number(total) - Number(used ?? 0);
  }
  updateEndpointInUse() {
    if (this.selectedEndpoint) {
      let update = {};
      for (let key in this.configOptions.endpoints) {
        update[key + '/inUse'] = null;
      }
      update[this.selectedEndpoint + '/inUse'] = true;
      FirebaseWorker.ref(`photoheight/company_space/${this.userGroup}/options/admin_dashboard/endpoints`)
        .update(update)
        .then(() => {
          this.toast('Endpoint URL updated.');
        });
    }
  }
  setSelectedEndpoint() {
    if (this.configOptions) {
      for (let key in this.configOptions.endpoints) {
        if (this.configOptions.endpoints[key].inUse) this.selectedEndpoint = key;
      }
    }
  }

  computePortalAdminStatus(currentUserData) {
    return currentUserData?.roles?.pole_app_portal?.pole_app_portal_admin;
  }

  // This function is used to convert the user_metadata_attributes object in the
  // company settings at options/admin_dashboard/user_metadata_attributes to an
  // array of the attributes that should be displayed in the user list
  computeUserListMetadataAttributes(user_metadata_attributes) {
    let list = [];
    if (user_metadata_attributes) {
      // Loop through the attributes to create a list of ones to display
      for (let key in user_metadata_attributes) {
        let attribute = user_metadata_attributes[key];
        // Check if we should show the attribute in the list
        if (attribute.display_in_user_list == true) {
          // Add the attribute name to the data
          attribute.attribute = key;
          // Add the attribute to the list
          list.push(attribute);
        }
      }
      // Sort the list by the order
      list.sort((a, b) => (a.order || 0) - (b.order || 0));
    }
    return list;
  }

  computeShowEmails(hideEmails) {
    this.showEmails = !hideEmails;
  }

  userGroupSpecificSettings() {
    if (!this.userGroup) return;

    // Set an interval to update Davey users' last active time every second
    if (this.userGroup == 'davey_resource_group_inc')
      this.durationIntervalId = setInterval(() => (this.durationTrigger = !this.durationTrigger), 1000);
  }

  promptAddLicense(e) {
    this.$.confirmAddLicenseDialog.open();
  }
  promptApproveUser(e) {
    this.approveUserTarget = e.detail.user;
    this.$.approveUserDialog.open();
  }
  promptChangeContactInfo() {
    this.$.editContactInfoDialog.open();
    this.editUserName = this.get('editUserData.name') || {};
  }
  promptCreateCompany() {
    this.$.createCompanyDialog.open();
  }
  checkboxClicked() {
    this.computeCanCreateWriteUser();
  }
  computeCanCreateWriteUser() {
    const hasEngineeringToolsChecked = Boolean(this.createUserWorkflows.find((x) => x.$key == 'engineering_tools' && x.$val)?.$val);
    const numAvailableWriteLicenses = this.subscription?.count - this.numLicensedUsers || 0; // No subscription count counts as 0 available write licenses
    const hasAvailableLicenses = numAvailableWriteLicenses > 0 || this.subscription?.count == 'Unlimited';
    this.canCreateWriteUser = !hasEngineeringToolsChecked || hasAvailableLicenses;
  }
  promptCreateUser() {
    this.createUserWorkflows = ToArray(this.currentUserData.workflows, true);
    if (this.createUserWorkflows.length > 1) this.createUserWorkflows.forEach((x) => (x.$val = false));
    this.showCreateUserWorkflows = this.createUserWorkflows.length > 1;
    this.showWriteOption = !!this.createUserWorkflows.find((x) => x.$key == 'engineering_tools' || x.$key == 'pole_app_portal');
    // reset write checkbox options
    this.isWriteUser = false;
    this.computeCanCreateWriteUser();
    this.createUserCompanyId = this.companyId;
    this.$.createUserDialog.open();
  }
  async addGoogleDriveIntegration() {
    let res = await firebase.functions().httpsCallable('googleOAuthGetAuthURL')();
    window.open(res.data.url);
  }
  showRemoveAccessButton() {
    const sharingLinkEstablished = Object.values(this.serverAccessSharingLinks ?? {}).find(
      (sharingLink) => sharingLink.recipient?.company_id == this.companyId
    );
    // This button should show if a user can send sharing links AND they are a super admin AND the current server is not the home server for the company AND their is a sharing link established
    return this.enabledFeatures?.can_share_server_access && this.systemAdmin && !this.isHomeServerForCompany && sharingLinkEstablished;
  }
  async removeServerAccess() {
    if (!this.serverAccessSharingLinks || !config.appName) return;
    // get the server access link
    const serverLinkEntry = Object.entries(this.serverAccessSharingLinks ?? {}).find(
      ([sharingLinkId, sharingLinkData]) => sharingLinkData.recipient?.company_id == this.companyId
    );
    if (!serverLinkEntry) return;
    const [serverAccessSharingLinkId, sharingLinkData] = serverLinkEntry;

    // show a dialog to confirm removing access
    const currentServerName = config.serverNames?.[config.appName] ?? 'Unknown Server';
    const dialog = KatapultDialog.confirm({
      text: `Are you sure you want to remove ${sharingLinkData.recipient.company} from ${currentServerName}?`,
      dialog: {
        title: 'Remove Company Server Access',
        color: 'var(--paper-red-500)',
        icon: 'delete'
      },
      confirmButton: { label: 'Remove Access', icon: 'delete' }
    });
    await dialog.confirmed;

    // Revoke the company's server access
    await CallCrossServerIdentityAction(globalThis.firebase.auth(), 'REVOKE_COMPANY_SERVER_ACCESS', {
      linkId: serverAccessSharingLinkId,
      companyId: this.companyId,
      targetServerId: config.appName
    });
  }
  showDeleteCompanyButton() {
    return this.systemAdmin && this.isHomeServerForCompany;
  }
  promptDeleteCompany() {
    this.deleteCompanyErrorMessage = null;
    this.$.deleteCompanyDialog.open();
  }
  promptDeleteUser(e) {
    this.deleteUserTarget = this.editUserRef;
    this.deleteUserErrorMessage = null;
    this.$.deleteUserDialog.open();
  }
  promptDenyUser(e) {
    this.denyUserTarget = e.detail.user;
    this.$.denyUserDialog.open();
  }
  promptResetPassword(e) {
    this.resetPasswordTarget = this.editUserRef;
    this.$.resetPasswordDialog.open();
  }
  promptUseMyHours(e) {
    this.$.useMyHoursDialog.open();
  }
  s(x) {
    return x == 1 ? '' : 's';
  }
  selectUser(e) {
    const { user } = e.detail;
    if (!user.pending_permission) this.editUserRef = user;
  }

  async exportUserData() {
    // Load in excel exports
    this.toast('Downloading User Data');
    await import('../katapult-maps-desktop/exports/excel-exports.js');

    // call excel exports runExport function
    await this.$.excelExports.runExport(
      'companyUsersExport',
      (exportData) => {
        this.toast('Download Complete');
        // Create a blob from the file data
        let fileBlob = new Blob([exportData.data], {
          type: exportData.mimeType
        });
        let url = URL.createObjectURL(fileBlob);
        var a = document.createElement('a');
        a.href = url;
        a.download = `${this.camelCase(this.companyId)} Company Users`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      { scope: this }
    );
  }
  async exportAllUserData() {
    // Load in excel exports
    this.toast('Downloading User Data');
    await import('../katapult-maps-desktop/exports/excel-exports.js');

    // call excel exports runExport function
    await this.$.excelExports.runExport(
      'allUserDataExport',
      (exportData) => {
        this.toast('Download Complete');
        // Create a blob from the file data
        let fileBlob = new Blob([exportData.data], {
          type: exportData.mimeType
        });
        let url = URL.createObjectURL(fileBlob);
        var a = document.createElement('a');
        a.href = url;
        a.download = `${this.camelCase(this.companyId)} Company Users`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      },
      { scope: this }
    );
  }
  async exportCrossServerUserPermissionsData(e) {
    const includeRoles = e.target.id == 'exportCrossServerUserPermissionsAndRoles';

    // Load in excel exports
    this.toast('Downloading User Data');
    await import('../katapult-maps-desktop/exports/excel-exports.js');

    // call excel exports runExport function
    await this.$.excelExports.runExport(
      'crossServerUserPermissions',
      (exportData) => {
        this.toast('Download Complete');
        // Create a blob from the file data
        let fileBlob = new Blob([exportData.data], {
          type: exportData.mimeType
        });
        let url = URL.createObjectURL(fileBlob);
        var a = document.createElement('a');
        a.href = url;
        a.download = `${this.camelCase(this.companyId)} Server Users Permissions`;
        document.body.appendChild(a);
        a.click();
      },
      { scope: this, includeRoles }
    );
  }
  async setUserSubscriptionGroup(e) {
    let input = e.currentTarget;
    if (this.get('subscription.group_attribute')) {
      input.disabled = true;
      await FirebaseWorker.ref(`users/${this.editUserRef.companyId}/${this.editUserRef.uid}/${this.subscription.group_attribute}`)
        .set(e.detail.value)
        .catch((err) => {
          input.value = e.detail.oldValue;
          this.toast(`Failed to set ${this.camelCase(this.subscription.group_attribute)}: ${err.message}`);
        })
        .finally(() => {
          input.disabled = false;
        });
    } else {
      input.value = e.detail.oldValue;
    }
  }
  // Updates user's metadata for the changed metadata attribute
  async setUserMetadata(e) {
    if (e && e.detail && e.detail.attribute_name) {
      let input = e.currentTarget;
      await FirebaseWorker.ref(`users/${this.editUserRef.companyId}/${this.editUserRef.uid}/metaData/${e.detail.attribute_name}`)
        .set(e.detail.value)
        .catch((err) => {
          input.value = e.detail.oldValue;
          this.toast(`Failed to set ${this.camelCase(e.detail.attribute_name)}: ${err.message}`);
        });
    }
  }
  setUserFlexPermission(e) {
    let toggle = this.shadowRoot.querySelector('#flexUserPermissionToggle');
    let checked = null;
    if (typeof e == 'object' && e.detail && e.detail.toggleSetting != null) {
      checked = Boolean(e.detail.toggleSetting);
    } else if (toggle) {
      checked = toggle.checked;
    }
    if (checked != null) {
      FirebaseWorker.ref(`users/${this.editUserRef.companyId}/${this.editUserRef.uid}/flex_user`).set(checked);
    }
  }
  async setUserLicensedPermission(e) {
    const checked = e.currentTarget.checked;
    // Get the toggle element and set it to disabled
    const toggle = this.shadowRoot.querySelector('#licensedToggle');
    toggle.disabled = true;

    if (checked === false) {
      // Prompt the user to confirm removing a license from the user
      const dialogConfig = KatapultDialog.confirm({
        text: `Are you sure you want to remove the license from ${this.editUserRef.email}? Doing so will disable write permission for this user on all servers they have access to.`,
        dialog: {
          title: 'Remove License',
          color: 'var(--paper-red-500)',
          icon: 'unlicense'
        },
        confirmButton: { label: 'Remove' }
      });

      const didConfirm = await dialogConfig.confirmed;

      // If the user cancelled, re-enable the toggle and return
      if (!didConfirm) {
        toggle.disabled = false;
        toggle.checked = true;
        return;
      }
    }

    // Make a call to the syncing server to add or remove a license for a user
    await CallCrossServerIdentityAction(globalThis.firebase.auth(), checked ? 'ADD_USER_LICENSE' : 'REMOVE_USER_LICENSE', {
      userId: this.editUserRef.uid
    });

    // Re-enable the toggle
    toggle.disabled = false;
  }
  /**
   * Sets the read permission for a user.
   * @param {Event} event - The event object from the checkbox input.
   * @returns {Promise<void>} A promise that resolves when the permission has been set.
   */
  async setUserReadPermission(event) {
    await SetUserReadPermission(this.editUserRef.uid, this.editUserRef.companyId, event?.currentTarget?.checked);
  }
  /**
   * Sets the write permission for a user.
   * If the write permission is turned off, it also turns off the flex user permission.
   * @returns {Promise<void>} A promise that resolves when the permission has been set.
   */
  async setUserWritePermission() {
    let toggle = this.shadowRoot?.querySelector('#writePermissionToggle');
    if (!toggle || !this.editUserRef?.companyId || !this.editUserRef?.uid) return;

    // Turn off the flex user if we are turning off write permission
    if (toggle && toggle.checked == false) {
      this.setUserFlexPermission({ detail: { toggleSetting: false } });
    }

    // Disable the toggle while we are setting the permission
    toggle.disabled = true;
    // Set write permission for the user
    let request = {
      companyId: this.editUserRef.companyId,
      uid: this.editUserRef.uid,
      write: toggle.checked
    };
    return globalThis.firebase
      .functions()
      .httpsCallable('setWritePermission')(request)
      .then((res) => {
        if (res.data && res.data.message) this.toast(res.data.message);
        toggle.disabled = false;
      })
      .catch(async (error) => {
        const duration = 10000;
        this.toast(`Error changing user's write permission. ${error.message}.`, duration);

        // Wait before re-setting the toggle because it's too jarring to reset it immediately
        await new Promise((resolve) => setTimeout(() => resolve(), duration));

        toggle.disabled = false;
        toggle.checked = true;
      });
  }
  someExist() {
    return Array.from(arguments).some((x) => this._exists(x));
  }
  toast(text, duration) {
    this.$.toast.text = text;
    if (duration) this.$.toast.duration = duration;
    this.$.toast.open();
  }
  getFullTimeEmployee() {
    return this.get('editUserData.employment.employment_type') == 'regular';
  }
  updateLocalStartDate(e) {
    let value = e.detail.value;
    // don't set the full time start date if the data is incomplete
    if (!value || value == 'Invalid Date' || isNaN(value)) return;
    this.fullTimeStartDate = value;
  }
  prepareFullTimeStartDateUpdate(e) {
    // skip the update if was an incomplete start date inputted
    if (!this.fullTimeStartDate) {
      this.fullTimeStartDateError = 'Please enter a valid date and time';
      return;
    }
    // clear the error
    this.fullTimeStartDateError = null;
    // call the event to update employment
    this.updateEmployment({
      currentTarget: e.currentTarget,
      detail: { value: this.fullTimeStartDate }
    });
  }
  updateEmployment(e) {
    if (this.editUserRef) {
      let attribute = e.currentTarget.dataset.attribute;
      let update = {};
      update[`users/${this.editUserRef.companyId}/${this.editUserRef.uid}/employment/${attribute}`] = e.detail.value;
      update[`photoheight/company_space/${this.editUserRef.companyId}/users/${this.editUserRef.uid}/employment/${attribute}`] =
        e.detail.value;
      FirebaseWorker.ref().update(update);
    }
  }
  // update the user's status for their company based on the dropdown selection
  updateUserStatus(e) {
    const status = e.currentTarget.dataset.status;
    let update = {};
    update[`users/${this.editUserRef.companyId}/${this.editUserRef.uid}/${status}`] = e.detail.value;
    update[`photoheight/company_space/${this.editUserRef.companyId}/users/${this.editUserRef.uid}/${status}`] = e.detail.value;
    FirebaseWorker.ref().update(update);
  }
  calcShowPortalAdmin(companyId, poleAppPortalWorkflow, utilityCompany, isPortalAdmin) {
    // only show the portal admin toggle if the user has a workflow of pole_app_portal
    // and either the company is the utility company or the user is a portal admin
    return poleAppPortalWorkflow && (companyId == utilityCompany || isPortalAdmin);
  }

  /** Returns true if the user can view the /admin page */
  _userCanViewPage() {
    const userExistsAndIsApproved = this.currentUserData != null && !this.currentUserData.pending_permission;
    const userIsPortalAdmin = this.currentUserData?.roles?.pole_app_portal?.pole_app_portal_admin || false;
    const userIsCsdUser = this.currentUserData?.roles?.photoheight?.support_dashboard_access;
    return userExistsAndIsApproved && (this.isAdmin || this.canReadAllUsers || userIsPortalAdmin == true || userIsCsdUser == true);
  }

  async openShareMLD() {
    if (this.selectedMLD) {
      await import('../share-job/share-job.js');
      let shareElement = this.$.editCompanyContainer.querySelector('#shareMLD');
      if (shareElement) shareElement.openMLDShare(this.selectedMLD);
    } else this.toast('Please select a master location directory to share.');
  }

  async updateMLDListListener() {
    if (this.unsubscribeMLDListListener) this.unsubscribeMLDListListener();

    // If we don't have a user group, we can't get the list of MLDs
    if (!this.userGroup) {
      this.mldList = [];
      return;
    }

    // Get the list of MLDs owned by the user's company (NOT including shared MLDs)
    this.unsubscribeMLDListListener = MLD.onDirectoryListSnapshot(this.userGroup, (directories) => {
      this.mldList = Object.values(directories).sort(MLD.SORT_DATE_CREATED_ASC);
    });
  }

  async mldSelected() {
    // set the companyNames based on sharing, any names passed in previously, and the contacts list
    // note: passing an empty array for sharing because we don't have a jobId to specify who we can share with
    if (this.selectedMLD) {
      let companyNames = await GetCompanyNames(this.contacts ?? [], [], this.sharingCompanyNames, FirebaseWorker);
      this.set('sharingCompanyNames', companyNames);

      // set sharing for the mld, which are the companies / models with mld is shared with already
      const selectedMLDData = this.mldList?.find((mld) => mld._id == this.selectedMLD);
      this.mldSharedWith = selectedMLDData._shared_with ?? {};
    }
  }

  computeIsHomeServerForCompany() {
    return this.enabledFeatures.limit_admin_actions_to_home_server ? this.companyHomeServer == this.config.appName : true;
  }

  computeHomeServerName(serverNames, serverId) {
    return serverNames?.[serverId] || serverId;
  }

  /**
   * Computes the title for the licensed toggle based on whether the server is a home server.
   * If the server is the home server for the company, the title will give information about what licenses do.
   * If the server is not the home server for the company, the title will indicate that the license can only be changed on the company's home server.
   * @returns {string} The computed toggle title.
   */
  computeLicensedToggleTitle() {
    return this.isHomeServerForCompany
      ? 'Add or remove a license for this user. Only licensed users are allowed to have write permission.'
      : "Licenses can only be changed on a company's home server. Please switch to this company's home server to add or remove a license.";
  }

  /**
   * Computes whether the write permission toggle should be disabled.
   * The write toggle is disabled if the cross_server_identity feature is enabled
   * and the user is not licensed.
   * @returns {boolean} `true` if the write toggle should be disabled, `false` otherwise.
   */
  computeWriteToggleDisabled() {
    return this.enabledFeatures.cross_server_identity && !this.editUserData?.licensed;
  }

  /**
   * Generates an attachment report for the given company and agreement number.
   */
  async generateAttachmentReport() {
    // Set the loading state
    this.attachmentReportLoading = true;
    // Setup the company with the utility records
    const utilityCompany = this.get(`config.firebaseData.utilityCompany`);
    // check to see if see have all of the necessary data
    if ((!this.companyId && !this.agreementNumber) || !utilityCompany) return;
    // Get the attachment records
    const attachmentRecords = await this.getAttachmentRecords(utilityCompany, this.companyId, this.agreementNumber);
    // Create a csv from the given attachment records
    let csvData = this.buildReportFromAttachmentRecords(attachmentRecords);
    // Download the csv
    this.downloadCSVData(csvData);
    // Set the loading state to false
    this.attachmentReportLoading = false;
  }

  /**
   * Gets the attachment records for a given utility company, owner company, and agreement number.  It paginates
   * through all of the records to get data more efficiently.
   * @param {String} utilityCompany - The utility company to get the attachment records from
   * @param {String} ownerCompany - The owner company to query the attachment records from
   * @param {Number} agreementNumber - The agreement number to query the attachment records from
   * @returns Array[Object] - An array of attachment records
   */
  async getAttachmentRecords(utilityCompany, ownerCompany, agreementNumber) {
    // Setup the amount of data to get for each chunk
    const batchSize = 2000;
    // Create the ref
    const attachmentRecordsRef = firebase.firestore().collection(`utility_records/${utilityCompany}/attachments`);
    // Get the records that match the owner company
    let attachmentRecordsCompanyQuery = attachmentRecordsRef.where('attachment_owner_company_id', '==', ownerCompany).limit(batchSize);
    // Get the records that match the agreement number
    let attachmentRecordsAgreementQuery = attachmentRecordsRef
      .where(`attachment_owner_company_id`, '!=', ownerCompany)
      .where('agreement_number', '==', agreementNumber)
      .limit(batchSize);
    // Setup an array to loop over to get the records
    let attachmentRecordsQueries = [attachmentRecordsCompanyQuery, attachmentRecordsAgreementQuery];
    // initialize a bucket to fill with attachment records
    const attachmentRecords = [];
    // First check company names, then check agreement numbers
    for (let query of attachmentRecordsQueries) {
      // get the first chunk of data
      let attachmentRecordsSnapshot = await query.get();
      // paginate through the data
      while (attachmentRecordsSnapshot.docs.length != 0) {
        // get the current chunk data
        attachmentRecordsSnapshot.forEach((doc) => {
          let data = doc.data();
          attachmentRecords.push(data);
          this.attachmentCount = attachmentRecords.length;
        });
        // move the cursor to the next chunk
        let lastVisible = attachmentRecordsSnapshot.docs[attachmentRecordsSnapshot.docs.length - 1];
        query = query.startAfter(lastVisible);
        attachmentRecordsSnapshot = await query.get();
      }
    }

    // return the records
    return attachmentRecords;
  }

  /**
   * Uses the given attachment records to build a csv string.  A list of attributes that should be retrieved
   * from each attachment record determines the data that will be included in the csv.
   * @param {Array[Object]} attachmentRecords - An array of attachment records to build the csv from
   * @returns String - A csv string built from the attachment records
   */
  buildReportFromAttachmentRecords(attachmentRecords) {
    // Define the attributes to get from the attachment records
    let attributes = [
      'agreement_number',
      'attachment_owner',
      'attachment_owner_company_id',
      'attachment_status',
      'attachment_type',
      'latitude',
      'longitude',
      'last_modified_at',
      'last_modified_by',
      'notes',
      'pole_id',
      'position_on_pole',
      'revisions_application',
      'revision_note'
    ];

    // Get the headers for the csv
    let headers = attributes.map((attribute) => capitalCase(attribute));
    let headerRow = headers.join(',');

    // Get the attribute data from each record
    let attachmentRecordRows = [];
    for (let record of Object.values(attachmentRecords)) {
      let data = attributes.map((attribute) => this.getAttributeData(attribute, record));
      // sanitize the data with esacpe characters
      let sanitizedData = data.map((d) => `"${d}"`);
      // Join with commas and push the attachment record row
      let row = sanitizedData.join(',');
      attachmentRecordRows.push(row);
    }

    // Join the headers with the attachment record data
    let csvData = [headerRow, ...attachmentRecordRows];
    // Create and return the csv string
    return csvData.join('\n');
  }

  /**
   * Gets data from a given record based on the given attribute.  If the attribute is latitude or longitude, the data
   * needs to be retrieved differently.  Otherwise, the attribute can just be used to index into the data.
   * @param {String} attribute - The attribute to get data from the record
   * @param {Object} record - The record to get the data from
   * @returns * - The data retrieved from the record
   */
  getAttributeData(attribute, record) {
    // get the data from the record
    let data = record[attribute];
    if (attribute == 'latitude') data = record['l']?.[0];
    else if (attribute == 'longitude') data = record['l']?.[1];

    // return an empty string if there was no data found for the attribute
    return data ?? '';
  }

  /**
   * Creates a csv file from the given csv string and downloads it.
   * @param {String} csvString - The csv string to build and download
   */
  downloadCSVData(csvString) {
    // create a blob from the csv string
    let blob = new Blob([csvString], { type: 'text/csv' });
    // create a url for the anchor tag to run
    let url = URL.createObjectURL(blob);
    // create and define the anchor element
    let a = document.createElement('a');
    a.href = url;
    a.download = `${this.companyId}(${this.agreementNumber ?? 'no_agreement'})_attachment_records.csv`;
    // click the anchor element to download the file
    a.click();
    document.body.removeChild(a);
  }

  /**
   * Sets the agreement number for a company.  This number is retrieved from the utility_info collection and
   * is tied to the current companyId.
   */
  async getAgreementNumber() {
    if (!this.companyId || !this.enabledFeatures.admin_attachment_records) {
      this.agreementNumber = null;
      return;
    }
    // Get the agreement number for the company
    const utilityCompany = this.get(`config.firebaseData.utilityCompany`);
    const agreementNumberPath = `utility_info/${utilityCompany}/attachers/${this.companyId}/agreement_number`;
    let agreementNumber = await FirebaseWorker.ref(agreementNumberPath)
      .once('value')
      .then((s) => s.val());
    this.agreementNumber = agreementNumber ?? null;
  }

  /**
   * Displays the agreement number for the company.  If there is no agreement number, a default message is displayed.
   * @returns String - The agreement number or a default message
   */
  displayAgreementNumber() {
    return this.agreementNumber ?? 'No Agreement Number';
  }

  /**
   * Event handler that toggles a user role for a user
   * @param {Event} event
   */
  async toggleUserRole(event) {
    const toggleButtonElement = /** @type {PaperToggleButtonElement} */ (event.target);
    const userRoleToSet = toggleButtonElement.dataset.userRole;
    if (!userRoleToSet) throw new Error('No user role to set');

    // Parse the "checked" property
    const grantRole = Boolean(toggleButtonElement.checked);

    // Set the user role
    await SetUserRole(this.editUserRef.uid, userRoleToSet, this.companyId, grantRole);
  }

  /** Updates the listener for the selected company's users' roles */
  updateCompanyUsersRolesListener() {
    if (this.unsubscribeEditUserRolesListener) this.unsubscribeEditUserRolesListener();

    // If we don't have a user ref or company id, don't set up the listener
    if (!this.companyId) return;

    const realtimeDB = /** @type {import('firebase/compat/app').default.database.Database} */ (globalThis.FirebaseWorker.database());
    const companyRolesRef = realtimeDB.ref(`roles/issuer_companies/${this.companyId}`);

    // Listen for changes to the user roles
    const listenerCallback = companyRolesRef.on('value', (snapshot) => {
      this.companyUsersRoles = snapshot.val()?.users ?? {};
    });

    // Set the unsubscribe function
    this.unsubscribeEditUserRolesListener = () => companyRolesRef.off('value', listenerCallback);
  }

  /**
   * Determines if a user role toggle should be disabled.
   * - If the user is a system admin, the toggle should never be disabled.
   * - If the user is a company admin, the toggle should not be disabled if the user has the role.
   * @param {string} userRole - The user role toggle
   * @returns {boolean}
   */
  roleToggleDisabled(userRole) {
    return !this.systemAdmin && !this.companyUsersRoles?.[this.user.uid]?.[userRole];
  }

  /**
   * Computes whether the company is verified.
   * @returns {boolean} Returns `true` if the company is verified, `false` if unverified.
   */
  computeIsCompanyVerified() {
    return !Boolean(this.companies?.[this.companyId]?.unverified);
  }

  /**
   * Computes whether the company is read-only based on if the company has any licenses.
   * If the company has no licenses, the company is read-only.
   * @returns {boolean} Returns `true` if the company is read-only, `false` if not.
   */
  computeIsCompanyReadOnly() {
    return !Boolean(this.subscription?.count);
  }

  updateRequestType(e) {
    this.requestType = e.detail.value;
  }

  async submitRequest() {
    this.submittingRequest = true;
    let valid = true;

    this.shadowRoot.querySelector('#useMyHoursTypeInput').invalid = false;
    this.shadowRoot.querySelector('#useMyHoursNotesInput').invalid = false;

    if (!this.requestType) {
      valid = false;
      this.shadowRoot.querySelector('#useMyHoursTypeInput').invalid = true;
    }
    if (!this.requestNote) {
      valid = false;
      this.shadowRoot.querySelector('#useMyHoursNotesInput').invalid = true;
    }

    if (valid) {
      let to = this.adminPageConfig?.request_email_addresses || ['support@katapultpro.com'];
      let body = 'New request from ' + this.currentUserData.email + ':\n\n';
      body += 'Request Type: ' + this.requestType + '\n\n';
      body += 'Notes: ' + this.requestNote + '\n\n';

      // if an internal user submitted this, add their details to the body
      const data = {
        addresses: to,
        subject: `New ${this.requestType} Request from ${this.currentUserData.email}`,
        body: body
      };
      await ServerRequest('email', data)
        .then(() => {
          this.toast('Request submitted successfully.');
          this.$.useMyHoursDialog.close();
        })
        .catch((err) => {
          this.toast('Error submitting request: ' + err.message);
        })
        .finally(() => {
          this.submittingRequest = false;
        });
      this.shadowRoot.querySelector('#useMyHoursTypeInput').value = '';
      this.shadowRoot.querySelector('#useMyHoursNotesInput').value = '';
    }
  }
}

window.customElements.define(AdminDashboard.is, AdminDashboard);
